/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ExternalCallsService {
  /** @summary Search */
  searchExternalCallsGet: {
    /** @summary Search */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<SearchExternalCallsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: SearchExternalCallsGetSchema,
        options: {
          parameters: SearchExternalCallsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<SearchExternalCallsGetData, SearchExternalCallsGetError>>
    ): Promise<RequestFnResponse<SearchExternalCallsGetData, SearchExternalCallsGetError>>;
    /** @summary Search */
    getQueryKey(
      parameters: DeepReadonly<SearchExternalCallsGetParameters> | void
    ): ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.searchExternalCallsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.searchExternalCallsGet.useQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchExternalCallsGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          SearchExternalCallsGetData,
          SearchExternalCallsGetError,
          TData,
          ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<SearchExternalCallsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.searchExternalCallsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.searchExternalCallsGet.useQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchExternalCallsGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          SearchExternalCallsGetData,
          SearchExternalCallsGetError,
          TData,
          ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<SearchExternalCallsGetError>>;
    /** @summary Search */
    getInfiniteQueryKey(
      parameters: DeepReadonly<SearchExternalCallsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.searchExternalCallsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchExternalCallsGetParameters,
      TQueryFnData = SearchExternalCallsGetData,
      TData = OperationInfiniteData<TQueryFnData, SearchExternalCallsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchExternalCallsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<SearchExternalCallsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.searchExternalCallsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchExternalCallsGetParameters,
      TQueryFnData = SearchExternalCallsGetData,
      TData = OperationInfiniteData<TQueryFnData, SearchExternalCallsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchExternalCallsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchExternalCallsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<SearchExternalCallsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const searchExternalCallsGetTotal = qraft.externalCallsService.searchExternalCallsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const searchExternalCallsGetByParametersTotal = qraft.externalCallsService.searchExternalCallsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             page: page
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const searchExternalCallsGetResults = qraft.externalCallsService.searchExternalCallsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchExternalCallsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const searchExternalCallsGetCombinedResults = qraft.externalCallsService.searchExternalCallsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchExternalCallsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          SearchExternalCallsGetSchema,
          SearchExternalCallsGetParameters,
          SearchExternalCallsGetData,
          SearchExternalCallsGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<SearchExternalCallsGetData, SearchExternalCallsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<SearchExternalCallsGetData, SearchExternalCallsGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.externalCallsService.searchExternalCallsGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.searchExternalCallsGet.useSuspenseQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = SearchExternalCallsGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          SearchExternalCallsGetData,
          SearchExternalCallsGetError,
          TData,
          ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<SearchExternalCallsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.searchExternalCallsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends SearchExternalCallsGetParameters, TData = SearchExternalCallsGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          SearchExternalCallsGetData,
          SearchExternalCallsGetError,
          OperationInfiniteData<TData, SearchExternalCallsGetParameters>,
          ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchExternalCallsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, SearchExternalCallsGetParameters>,
      OperationError<SearchExternalCallsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const searchExternalCallsGetData = qraft.externalCallsService.searchExternalCallsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchExternalCallsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const searchExternalCallsGetCombinedData = qraft.externalCallsService.searchExternalCallsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchExternalCallsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          SearchExternalCallsGetSchema,
          SearchExternalCallsGetParameters,
          SearchExternalCallsGetData,
          SearchExternalCallsGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<SearchExternalCallsGetData, SearchExternalCallsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<SearchExternalCallsGetData, SearchExternalCallsGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Search */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        SearchExternalCallsGetError
      > | void
    ): Promise<SearchExternalCallsGetData>;
    /** @summary Search */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        SearchExternalCallsGetError
      > | void
    ): Promise<void>;
    /** @summary Search */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        SearchExternalCallsGetError
      > | void
    ): Promise<SearchExternalCallsGetData>;
    /** @summary Search */
    fetchInfiniteQuery<TPageParam extends SearchExternalCallsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        DeepReadonly<TPageParam>,
        SearchExternalCallsGetError
      > | void
    ): Promise<OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>>;
    /** @summary Search */
    prefetchInfiniteQuery<TPageParam extends SearchExternalCallsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        DeepReadonly<TPageParam>,
        SearchExternalCallsGetError
      > | void
    ): Promise<void>;
    /** @summary Search */
    ensureInfiniteQueryData<TPageParam extends SearchExternalCallsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        DeepReadonly<TPageParam>,
        SearchExternalCallsGetError
      > | void
    ): Promise<OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>>;
    /** @summary Search */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void)
    ): SearchExternalCallsGetData | undefined;
    /** @summary Search */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void)
    ): OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters> | undefined;
    /** @summary Search */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
            data:
              | NoInfer<OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
            data: SearchExternalCallsGetData | undefined,
          ]
        >;
    /** @summary Search */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void)
    ): QueryState<SearchExternalCallsGetData, SearchExternalCallsGetError> | undefined;
    /** @summary Search */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<SearchExternalCallsGetParameters>
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>,
          SearchExternalCallsGetError
        >
      | undefined;
    /** @summary Search */
    setQueryData(
      parameters:
        | (DeepReadonly<SearchExternalCallsGetParameters> | undefined)
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
      updater: Updater<
        NoInfer<SearchExternalCallsGetData> | undefined,
        NoInfer<DeepReadonly<SearchExternalCallsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): SearchExternalCallsGetData | undefined;
    /** @summary Search */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<SearchExternalCallsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters> | undefined;
    /** @summary Search */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >,
      updater: Updater<
        NoInfer<SearchExternalCallsGetData> | undefined,
        NoInfer<SearchExternalCallsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<SearchExternalCallsGetData | undefined>;
    /** @summary Search */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        TInfinite,
        SearchExternalCallsGetParameters,
        SearchExternalCallsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Search */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Search */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Search */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
    ): void;
    /** @summary Search */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Search */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
    ): number;
    schema: SearchExternalCallsGetSchema;
    types: {
      parameters: SearchExternalCallsGetParameters;
      data: SearchExternalCallsGetData;
      error: SearchExternalCallsGetError;
    };
  };
  /** @summary Metrics Registry */
  metricsRegistryExternalCallsMetricsRegistryGet: {
    /** @summary Metrics Registry */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<MetricsRegistryExternalCallsMetricsRegistryGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        options: {
          parameters: MetricsRegistryExternalCallsMetricsRegistryGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      >
    >;
    /** @summary Metrics Registry */
    getQueryKey(
      parameters: DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void
    ): ServiceOperationQueryKey<
      MetricsRegistryExternalCallsMetricsRegistryGetSchema,
      MetricsRegistryExternalCallsMetricsRegistryGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useQuery()
     * ```
     */
    useQuery<TData = MetricsRegistryExternalCallsMetricsRegistryGetData>(
      parameters:
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          TData,
          ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useQuery()
     * ```
     */
    useQuery<TData = MetricsRegistryExternalCallsMetricsRegistryGetData>(
      parameters:
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          TData,
          ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>>;
    /** @summary Metrics Registry */
    getInfiniteQueryKey(
      parameters: DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      MetricsRegistryExternalCallsMetricsRegistryGetSchema,
      MetricsRegistryExternalCallsMetricsRegistryGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters,
      TQueryFnData = MetricsRegistryExternalCallsMetricsRegistryGetData,
      TData = OperationInfiniteData<TQueryFnData, MetricsRegistryExternalCallsMetricsRegistryGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters,
      TQueryFnData = MetricsRegistryExternalCallsMetricsRegistryGetData,
      TData = OperationInfiniteData<TQueryFnData, MetricsRegistryExternalCallsMetricsRegistryGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const metricsRegistryExternalCallsMetricsRegistryGetTotal = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const metricsRegistryExternalCallsMetricsRegistryGetResults = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * metricsRegistryExternalCallsMetricsRegistryGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const metricsRegistryExternalCallsMetricsRegistryGetCombinedResults = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * metricsRegistryExternalCallsMetricsRegistryGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          MetricsRegistryExternalCallsMetricsRegistryGetSchema,
          MetricsRegistryExternalCallsMetricsRegistryGetParameters,
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = MetricsRegistryExternalCallsMetricsRegistryGetData>(
      parameters:
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          TData,
          ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters,
      TData = MetricsRegistryExternalCallsMetricsRegistryGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          OperationInfiniteData<TData, MetricsRegistryExternalCallsMetricsRegistryGetParameters>,
          ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, MetricsRegistryExternalCallsMetricsRegistryGetParameters>,
      OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const metricsRegistryExternalCallsMetricsRegistryGetData = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * metricsRegistryExternalCallsMetricsRegistryGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const metricsRegistryExternalCallsMetricsRegistryGetCombinedData = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * metricsRegistryExternalCallsMetricsRegistryGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          MetricsRegistryExternalCallsMetricsRegistryGetSchema,
          MetricsRegistryExternalCallsMetricsRegistryGetParameters,
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              MetricsRegistryExternalCallsMetricsRegistryGetData,
              MetricsRegistryExternalCallsMetricsRegistryGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Metrics Registry */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<MetricsRegistryExternalCallsMetricsRegistryGetData>;
    /** @summary Metrics Registry */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<void>;
    /** @summary Metrics Registry */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<MetricsRegistryExternalCallsMetricsRegistryGetData>;
    /** @summary Metrics Registry */
    fetchInfiniteQuery<TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        DeepReadonly<TPageParam>,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters
      >
    >;
    /** @summary Metrics Registry */
    prefetchInfiniteQuery<TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        DeepReadonly<TPageParam>,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<void>;
    /** @summary Metrics Registry */
    ensureInfiniteQueryData<TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        DeepReadonly<TPageParam>,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters
      >
    >;
    /** @summary Metrics Registry */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void)
    ): MetricsRegistryExternalCallsMetricsRegistryGetData | undefined;
    /** @summary Metrics Registry */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void)
    ):
      | OperationInfiniteData<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetParameters
        >
      | undefined;
    /** @summary Metrics Registry */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              MetricsRegistryExternalCallsMetricsRegistryGetSchema,
              MetricsRegistryExternalCallsMetricsRegistryGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    MetricsRegistryExternalCallsMetricsRegistryGetData,
                    MetricsRegistryExternalCallsMetricsRegistryGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              MetricsRegistryExternalCallsMetricsRegistryGetSchema,
              MetricsRegistryExternalCallsMetricsRegistryGetParameters
            >,
            data: MetricsRegistryExternalCallsMetricsRegistryGetData | undefined,
          ]
        >;
    /** @summary Metrics Registry */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void)
    ):
      | QueryState<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      | undefined;
    /** @summary Metrics Registry */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters>
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      | undefined;
    /** @summary Metrics Registry */
    setQueryData(
      parameters:
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | undefined)
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
      updater: Updater<
        NoInfer<MetricsRegistryExternalCallsMetricsRegistryGetData> | undefined,
        NoInfer<DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetData>> | undefined
      >,
      options?: SetDataOptions
    ): MetricsRegistryExternalCallsMetricsRegistryGetData | undefined;
    /** @summary Metrics Registry */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              MetricsRegistryExternalCallsMetricsRegistryGetData,
              MetricsRegistryExternalCallsMetricsRegistryGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                MetricsRegistryExternalCallsMetricsRegistryGetData,
                MetricsRegistryExternalCallsMetricsRegistryGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetParameters
        >
      | undefined;
    /** @summary Metrics Registry */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >,
      updater: Updater<
        NoInfer<MetricsRegistryExternalCallsMetricsRegistryGetData> | undefined,
        NoInfer<MetricsRegistryExternalCallsMetricsRegistryGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<MetricsRegistryExternalCallsMetricsRegistryGetData | undefined>;
    /** @summary Metrics Registry */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        TInfinite,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Metrics Registry */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Metrics Registry */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Metrics Registry */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
    ): void;
    /** @summary Metrics Registry */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Metrics Registry */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
    ): number;
    schema: MetricsRegistryExternalCallsMetricsRegistryGetSchema;
    types: {
      parameters: MetricsRegistryExternalCallsMetricsRegistryGetParameters;
      data: MetricsRegistryExternalCallsMetricsRegistryGetData;
      error: MetricsRegistryExternalCallsMetricsRegistryGetError;
    };
  };
  /**
   * @summary Unmapped Extensions
   * @description SOL-2636 Point 4. Recent inbound extensions with no employee
   * mapping -- drives the dashboard banner.
   */
  unmappedExtensions: {
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<UnmappedExtensionsParameters, TMeta, TSignal> | void),
      client?: (
        schema: UnmappedExtensionsSchema,
        options: {
          parameters: UnmappedExtensionsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<UnmappedExtensionsData, UnmappedExtensionsError>>
    ): Promise<RequestFnResponse<UnmappedExtensionsData, UnmappedExtensionsError>>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    getQueryKey(
      parameters: DeepReadonly<UnmappedExtensionsParameters> | void
    ): ServiceOperationQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.unmappedExtensions.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.unmappedExtensions.useQuery({
     *     query: {
     *         days: days
     *     }
     * })
     * ```
     */
    useQuery<TData = UnmappedExtensionsData>(
      parameters:
        | ServiceOperationQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        | (DeepReadonly<UnmappedExtensionsParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          UnmappedExtensionsData,
          UnmappedExtensionsError,
          TData,
          ServiceOperationQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<UnmappedExtensionsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.unmappedExtensions.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.unmappedExtensions.useQuery({
     *     query: {
     *         days: days
     *     }
     * })
     * ```
     */
    useQuery<TData = UnmappedExtensionsData>(
      parameters:
        | ServiceOperationQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        | (DeepReadonly<UnmappedExtensionsParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          UnmappedExtensionsData,
          UnmappedExtensionsError,
          TData,
          ServiceOperationQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<UnmappedExtensionsError>>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<UnmappedExtensionsParameters> | void
    ): ServiceOperationInfiniteQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.unmappedExtensions.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             days: initialDays
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends UnmappedExtensionsParameters,
      TQueryFnData = UnmappedExtensionsData,
      TData = OperationInfiniteData<TQueryFnData, UnmappedExtensionsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        | (DeepReadonly<UnmappedExtensionsParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          UnmappedExtensionsError,
          TData,
          ServiceOperationInfiniteQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<UnmappedExtensionsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.unmappedExtensions.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             days: initialDays
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends UnmappedExtensionsParameters,
      TQueryFnData = UnmappedExtensionsData,
      TData = OperationInfiniteData<TQueryFnData, UnmappedExtensionsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        | (DeepReadonly<UnmappedExtensionsParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          UnmappedExtensionsError,
          TData,
          ServiceOperationInfiniteQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<UnmappedExtensionsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<UnmappedExtensionsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const unmappedExtensionsTotal = qraft.externalCallsService.unmappedExtensions.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const unmappedExtensionsByParametersTotal = qraft.externalCallsService.unmappedExtensions.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             days: days
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
        | QueryFiltersByQueryKey<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const unmappedExtensionsResults = qraft.externalCallsService.unmappedExtensions.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 days: days1
     *             }
     *         },
     *         {
     *             query: {
     *                 days: days2
     *             }
     *         }
     *     ]
     * });
     * unmappedExtensionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const unmappedExtensionsCombinedResults = qraft.externalCallsService.unmappedExtensions.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 days: days1
     *             }
     *         },
     *         {
     *             query: {
     *                 days: days2
     *             }
     *         }
     *     ]
     * });
     * unmappedExtensionsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          UnmappedExtensionsSchema,
          UnmappedExtensionsParameters,
          UnmappedExtensionsData,
          UnmappedExtensionsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<UnmappedExtensionsData, UnmappedExtensionsError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<UnmappedExtensionsData, UnmappedExtensionsError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.externalCallsService.unmappedExtensions.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.unmappedExtensions.useSuspenseQuery({
     *     query: {
     *         days: days
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = UnmappedExtensionsData>(
      parameters:
        | ServiceOperationQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        | (DeepReadonly<UnmappedExtensionsParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          UnmappedExtensionsData,
          UnmappedExtensionsError,
          TData,
          ServiceOperationQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<UnmappedExtensionsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.unmappedExtensions.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             days: initialDays
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends UnmappedExtensionsParameters, TData = UnmappedExtensionsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        | (DeepReadonly<UnmappedExtensionsParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          UnmappedExtensionsData,
          UnmappedExtensionsError,
          OperationInfiniteData<TData, UnmappedExtensionsParameters>,
          ServiceOperationInfiniteQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<UnmappedExtensionsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, UnmappedExtensionsParameters>,
      OperationError<UnmappedExtensionsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const unmappedExtensionsData = qraft.externalCallsService.unmappedExtensions.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 days: days1
     *             }
     *         },
     *         {
     *             query: {
     *                 days: days2
     *             }
     *         }
     *     ]
     * });
     * unmappedExtensionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const unmappedExtensionsCombinedData = qraft.externalCallsService.unmappedExtensions.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 days: days1
     *             }
     *         },
     *         {
     *             query: {
     *                 days: days2
     *             }
     *         }
     *     ]
     * });
     * unmappedExtensionsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          UnmappedExtensionsSchema,
          UnmappedExtensionsParameters,
          UnmappedExtensionsData,
          UnmappedExtensionsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<UnmappedExtensionsData, UnmappedExtensionsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<UnmappedExtensionsData, UnmappedExtensionsError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        UnmappedExtensionsSchema,
        UnmappedExtensionsData,
        UnmappedExtensionsParameters,
        UnmappedExtensionsError
      > | void
    ): Promise<UnmappedExtensionsData>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        UnmappedExtensionsSchema,
        UnmappedExtensionsData,
        UnmappedExtensionsParameters,
        UnmappedExtensionsError
      > | void
    ): Promise<void>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        UnmappedExtensionsSchema,
        UnmappedExtensionsData,
        UnmappedExtensionsParameters,
        UnmappedExtensionsError
      > | void
    ): Promise<UnmappedExtensionsData>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    fetchInfiniteQuery<TPageParam extends UnmappedExtensionsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        UnmappedExtensionsSchema,
        UnmappedExtensionsData,
        UnmappedExtensionsParameters,
        DeepReadonly<TPageParam>,
        UnmappedExtensionsError
      > | void
    ): Promise<OperationInfiniteData<UnmappedExtensionsData, UnmappedExtensionsParameters>>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    prefetchInfiniteQuery<TPageParam extends UnmappedExtensionsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        UnmappedExtensionsSchema,
        UnmappedExtensionsData,
        UnmappedExtensionsParameters,
        DeepReadonly<TPageParam>,
        UnmappedExtensionsError
      > | void
    ): Promise<void>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    ensureInfiniteQueryData<TPageParam extends UnmappedExtensionsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        UnmappedExtensionsSchema,
        UnmappedExtensionsData,
        UnmappedExtensionsParameters,
        DeepReadonly<TPageParam>,
        UnmappedExtensionsError
      > | void
    ): Promise<OperationInfiniteData<UnmappedExtensionsData, UnmappedExtensionsParameters>>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        | (DeepReadonly<UnmappedExtensionsParameters> | void)
    ): UnmappedExtensionsData | undefined;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        | (DeepReadonly<UnmappedExtensionsParameters> | void)
    ): OperationInfiniteData<UnmappedExtensionsData, UnmappedExtensionsParameters> | undefined;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
        | QueryFiltersByQueryKey<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>,
            data: NoInfer<OperationInfiniteData<UnmappedExtensionsData, UnmappedExtensionsParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>,
            data: UnmappedExtensionsData | undefined,
          ]
        >;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        | (DeepReadonly<UnmappedExtensionsParameters> | void)
    ): QueryState<UnmappedExtensionsData, UnmappedExtensionsError> | undefined;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<UnmappedExtensionsParameters>
        | ServiceOperationInfiniteQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<UnmappedExtensionsData, UnmappedExtensionsParameters>, UnmappedExtensionsError>
      | undefined;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<UnmappedExtensionsParameters> | undefined)
        | ServiceOperationQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>,
      updater: Updater<
        NoInfer<UnmappedExtensionsData> | undefined,
        NoInfer<DeepReadonly<UnmappedExtensionsData>> | undefined
      >,
      options?: SetDataOptions
    ): UnmappedExtensionsData | undefined;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<UnmappedExtensionsParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<UnmappedExtensionsSchema, UnmappedExtensionsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<UnmappedExtensionsData, UnmappedExtensionsParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<UnmappedExtensionsData, UnmappedExtensionsParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<UnmappedExtensionsData, UnmappedExtensionsParameters> | undefined;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
        | QueryFiltersByQueryKey<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >,
      updater: Updater<NoInfer<UnmappedExtensionsData> | undefined, NoInfer<UnmappedExtensionsData> | undefined>,
      options?: SetDataOptions
    ): Array<UnmappedExtensionsData | undefined>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        UnmappedExtensionsSchema,
        UnmappedExtensionsData,
        TInfinite,
        UnmappedExtensionsParameters,
        UnmappedExtensionsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
        | QueryFiltersByQueryKey<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
        | QueryFiltersByQueryKey<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
        | QueryFiltersByQueryKey<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
    ): void;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
        | QueryFiltersByQueryKey<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Unmapped Extensions
     * @description SOL-2636 Point 4. Recent inbound extensions with no employee
     * mapping -- drives the dashboard banner.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
        | QueryFiltersByQueryKey<
            UnmappedExtensionsSchema,
            UnmappedExtensionsData,
            TInfinite,
            UnmappedExtensionsParameters,
            UnmappedExtensionsError
          >
    ): number;
    schema: UnmappedExtensionsSchema;
    types: {
      parameters: UnmappedExtensionsParameters;
      data: UnmappedExtensionsData;
      error: UnmappedExtensionsError;
    };
  };
  /**
   * @summary Backfill Attribution Preview
   * @description SOL-2636 Point 7. Preview the row count the backfill button
   * would re-attribute under the current dashboard filters.
   */
  backfillAttributionPreview: {
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<BackfillAttributionPreviewParameters, TMeta, TSignal> | void),
      client?: (
        schema: BackfillAttributionPreviewSchema,
        options: {
          parameters: BackfillAttributionPreviewParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<BackfillAttributionPreviewData, BackfillAttributionPreviewError>>
    ): Promise<RequestFnResponse<BackfillAttributionPreviewData, BackfillAttributionPreviewError>>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    getQueryKey(
      parameters: DeepReadonly<BackfillAttributionPreviewParameters> | void
    ): ServiceOperationQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.backfillAttributionPreview.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.backfillAttributionPreview.useQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useQuery<TData = BackfillAttributionPreviewData>(
      parameters:
        | ServiceOperationQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        | (DeepReadonly<BackfillAttributionPreviewParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          BackfillAttributionPreviewData,
          BackfillAttributionPreviewError,
          TData,
          ServiceOperationQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<BackfillAttributionPreviewError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.backfillAttributionPreview.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.backfillAttributionPreview.useQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useQuery<TData = BackfillAttributionPreviewData>(
      parameters:
        | ServiceOperationQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        | (DeepReadonly<BackfillAttributionPreviewParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          BackfillAttributionPreviewData,
          BackfillAttributionPreviewError,
          TData,
          ServiceOperationQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<BackfillAttributionPreviewError>>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<BackfillAttributionPreviewParameters> | void
    ): ServiceOperationInfiniteQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.backfillAttributionPreview.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends BackfillAttributionPreviewParameters,
      TQueryFnData = BackfillAttributionPreviewData,
      TData = OperationInfiniteData<TQueryFnData, BackfillAttributionPreviewParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        | (DeepReadonly<BackfillAttributionPreviewParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          BackfillAttributionPreviewError,
          TData,
          ServiceOperationInfiniteQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<BackfillAttributionPreviewError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.backfillAttributionPreview.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends BackfillAttributionPreviewParameters,
      TQueryFnData = BackfillAttributionPreviewData,
      TData = OperationInfiniteData<TQueryFnData, BackfillAttributionPreviewParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        | (DeepReadonly<BackfillAttributionPreviewParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          BackfillAttributionPreviewError,
          TData,
          ServiceOperationInfiniteQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<BackfillAttributionPreviewData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<BackfillAttributionPreviewError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const backfillAttributionPreviewTotal = qraft.externalCallsService.backfillAttributionPreview.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const backfillAttributionPreviewByParametersTotal = qraft.externalCallsService.backfillAttributionPreview.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             start_time__gte: startTimeGte
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
        | QueryFiltersByQueryKey<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const backfillAttributionPreviewResults = qraft.externalCallsService.backfillAttributionPreview.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * backfillAttributionPreviewResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const backfillAttributionPreviewCombinedResults = qraft.externalCallsService.backfillAttributionPreview.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * backfillAttributionPreviewCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          BackfillAttributionPreviewSchema,
          BackfillAttributionPreviewParameters,
          BackfillAttributionPreviewData,
          BackfillAttributionPreviewError
        >
      >,
      TCombinedResult = Array<UseQueryResult<BackfillAttributionPreviewData, BackfillAttributionPreviewError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<BackfillAttributionPreviewData, BackfillAttributionPreviewError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.externalCallsService.backfillAttributionPreview.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.backfillAttributionPreview.useSuspenseQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = BackfillAttributionPreviewData>(
      parameters:
        | ServiceOperationQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        | (DeepReadonly<BackfillAttributionPreviewParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          BackfillAttributionPreviewData,
          BackfillAttributionPreviewError,
          TData,
          ServiceOperationQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<BackfillAttributionPreviewError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.backfillAttributionPreview.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends BackfillAttributionPreviewParameters,
      TData = BackfillAttributionPreviewData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        | (DeepReadonly<BackfillAttributionPreviewParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          BackfillAttributionPreviewData,
          BackfillAttributionPreviewError,
          OperationInfiniteData<TData, BackfillAttributionPreviewParameters>,
          ServiceOperationInfiniteQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<BackfillAttributionPreviewData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, BackfillAttributionPreviewParameters>,
      OperationError<BackfillAttributionPreviewError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const backfillAttributionPreviewData = qraft.externalCallsService.backfillAttributionPreview.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * backfillAttributionPreviewResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const backfillAttributionPreviewCombinedData = qraft.externalCallsService.backfillAttributionPreview.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * backfillAttributionPreviewCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          BackfillAttributionPreviewSchema,
          BackfillAttributionPreviewParameters,
          BackfillAttributionPreviewData,
          BackfillAttributionPreviewError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<BackfillAttributionPreviewData, BackfillAttributionPreviewError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<BackfillAttributionPreviewData, BackfillAttributionPreviewError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        BackfillAttributionPreviewSchema,
        BackfillAttributionPreviewData,
        BackfillAttributionPreviewParameters,
        BackfillAttributionPreviewError
      > | void
    ): Promise<BackfillAttributionPreviewData>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        BackfillAttributionPreviewSchema,
        BackfillAttributionPreviewData,
        BackfillAttributionPreviewParameters,
        BackfillAttributionPreviewError
      > | void
    ): Promise<void>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        BackfillAttributionPreviewSchema,
        BackfillAttributionPreviewData,
        BackfillAttributionPreviewParameters,
        BackfillAttributionPreviewError
      > | void
    ): Promise<BackfillAttributionPreviewData>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    fetchInfiniteQuery<TPageParam extends BackfillAttributionPreviewParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        BackfillAttributionPreviewSchema,
        BackfillAttributionPreviewData,
        BackfillAttributionPreviewParameters,
        DeepReadonly<TPageParam>,
        BackfillAttributionPreviewError
      > | void
    ): Promise<OperationInfiniteData<BackfillAttributionPreviewData, BackfillAttributionPreviewParameters>>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    prefetchInfiniteQuery<TPageParam extends BackfillAttributionPreviewParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        BackfillAttributionPreviewSchema,
        BackfillAttributionPreviewData,
        BackfillAttributionPreviewParameters,
        DeepReadonly<TPageParam>,
        BackfillAttributionPreviewError
      > | void
    ): Promise<void>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    ensureInfiniteQueryData<TPageParam extends BackfillAttributionPreviewParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        BackfillAttributionPreviewSchema,
        BackfillAttributionPreviewData,
        BackfillAttributionPreviewParameters,
        DeepReadonly<TPageParam>,
        BackfillAttributionPreviewError
      > | void
    ): Promise<OperationInfiniteData<BackfillAttributionPreviewData, BackfillAttributionPreviewParameters>>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        | (DeepReadonly<BackfillAttributionPreviewParameters> | void)
    ): BackfillAttributionPreviewData | undefined;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        | (DeepReadonly<BackfillAttributionPreviewParameters> | void)
    ): OperationInfiniteData<BackfillAttributionPreviewData, BackfillAttributionPreviewParameters> | undefined;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
        | QueryFiltersByQueryKey<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              BackfillAttributionPreviewSchema,
              BackfillAttributionPreviewParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<BackfillAttributionPreviewData, BackfillAttributionPreviewParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>,
            data: BackfillAttributionPreviewData | undefined,
          ]
        >;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        | (DeepReadonly<BackfillAttributionPreviewParameters> | void)
    ): QueryState<BackfillAttributionPreviewData, BackfillAttributionPreviewError> | undefined;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<BackfillAttributionPreviewParameters>
        | ServiceOperationInfiniteQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<BackfillAttributionPreviewData, BackfillAttributionPreviewParameters>,
          BackfillAttributionPreviewError
        >
      | undefined;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<BackfillAttributionPreviewParameters> | undefined)
        | ServiceOperationQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>,
      updater: Updater<
        NoInfer<BackfillAttributionPreviewData> | undefined,
        NoInfer<DeepReadonly<BackfillAttributionPreviewData>> | undefined
      >,
      options?: SetDataOptions
    ): BackfillAttributionPreviewData | undefined;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<BackfillAttributionPreviewParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<BackfillAttributionPreviewSchema, BackfillAttributionPreviewParameters>,
      updater: Updater<
        | NoInfer<OperationInfiniteData<BackfillAttributionPreviewData, BackfillAttributionPreviewParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<OperationInfiniteData<BackfillAttributionPreviewData, BackfillAttributionPreviewParameters>>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<BackfillAttributionPreviewData, BackfillAttributionPreviewParameters> | undefined;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
        | QueryFiltersByQueryKey<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >,
      updater: Updater<
        NoInfer<BackfillAttributionPreviewData> | undefined,
        NoInfer<BackfillAttributionPreviewData> | undefined
      >,
      options?: SetDataOptions
    ): Array<BackfillAttributionPreviewData | undefined>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        BackfillAttributionPreviewSchema,
        BackfillAttributionPreviewData,
        TInfinite,
        BackfillAttributionPreviewParameters,
        BackfillAttributionPreviewError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
        | QueryFiltersByQueryKey<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
        | QueryFiltersByQueryKey<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
        | QueryFiltersByQueryKey<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
    ): void;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
        | QueryFiltersByQueryKey<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Backfill Attribution Preview
     * @description SOL-2636 Point 7. Preview the row count the backfill button
     * would re-attribute under the current dashboard filters.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
        | QueryFiltersByQueryKey<
            BackfillAttributionPreviewSchema,
            BackfillAttributionPreviewData,
            TInfinite,
            BackfillAttributionPreviewParameters,
            BackfillAttributionPreviewError
          >
    ): number;
    schema: BackfillAttributionPreviewSchema;
    types: {
      parameters: BackfillAttributionPreviewParameters;
      data: BackfillAttributionPreviewData;
      error: BackfillAttributionPreviewError;
    };
  };
  /**
   * @summary Backfill Attribution
   * @description SOL-2636 Point 7. Execute the historic re-attribution under the
   * current dashboard filters. Server-side hard limit 10,000 rows --
   * larger backfills go through scripts/backfill_recon_attribution.py
   * (chunked + retry semantics).
   */
  backfillAttribution: {
    /**
     * @summary Backfill Attribution
     * @description SOL-2636 Point 7. Execute the historic re-attribution under the
     * current dashboard filters. Server-side hard limit 10,000 rows --
     * larger backfills go through scripts/backfill_recon_attribution.py
     * (chunked + retry semantics).
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        BackfillAttributionBody,
        BackfillAttributionParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: BackfillAttributionSchema,
        options: ServiceOperationMutationFnOptions<
          BackfillAttributionBody,
          BackfillAttributionParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<BackfillAttributionData, BackfillAttributionError>>
    ): Promise<RequestFnResponse<BackfillAttributionData, BackfillAttributionError>>;
    /**
     * @summary Backfill Attribution
     * @description SOL-2636 Point 7. Execute the historic re-attribution under the
     * current dashboard filters. Server-side hard limit 10,000 rows --
     * larger backfills go through scripts/backfill_recon_attribution.py
     * (chunked + retry semantics).
     */
    getMutationKey(
      parameters: DeepReadonly<BackfillAttributionParameters> | void
    ): ServiceOperationMutationKey<BackfillAttributionSchema, BackfillAttributionParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Backfill Attribution
     * @description SOL-2636 Point 7. Execute the historic re-attribution under the
     * current dashboard filters. Server-side hard limit 10,000 rows --
     * larger backfills go through scripts/backfill_recon_attribution.py
     * (chunked + retry semantics).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.backfillAttribution.useMutation({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.backfillAttribution.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends BackfillAttributionBody, TContext = unknown>(
      parameters: DeepReadonly<BackfillAttributionParameters>,
      options?: ServiceOperationUseMutationOptions<
        BackfillAttributionSchema,
        BackfillAttributionData,
        BackfillAttributionParameters,
        TVariables,
        OperationError<BackfillAttributionError>,
        TContext
      >
    ): UseMutationResult<BackfillAttributionData, OperationError<BackfillAttributionError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Backfill Attribution
     * @description SOL-2636 Point 7. Execute the historic re-attribution under the
     * current dashboard filters. Server-side hard limit 10,000 rows --
     * larger backfills go through scripts/backfill_recon_attribution.py
     * (chunked + retry semantics).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.backfillAttribution.useMutation({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.backfillAttribution.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<BackfillAttributionBody, BackfillAttributionParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        BackfillAttributionSchema,
        BackfillAttributionData,
        BackfillAttributionParameters,
        TVariables,
        OperationError<BackfillAttributionError>,
        TContext
      >
    ): UseMutationResult<BackfillAttributionData, OperationError<BackfillAttributionError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Backfill Attribution
     * @description SOL-2636 Point 7. Execute the historic re-attribution under the
     * current dashboard filters. Server-side hard limit 10,000 rows --
     * larger backfills go through scripts/backfill_recon_attribution.py
     * (chunked + retry semantics).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const backfillAttributionTotal = qraft.externalCallsService.backfillAttribution.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const backfillAttributionTotal = qraft.externalCallsService.backfillAttribution.useIsMutating({
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            BackfillAttributionBody,
            BackfillAttributionData,
            BackfillAttributionParameters,
            OperationError<BackfillAttributionError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BackfillAttributionSchema,
            BackfillAttributionBody,
            BackfillAttributionData,
            BackfillAttributionParameters,
            OperationError<BackfillAttributionError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Backfill Attribution
     * @description SOL-2636 Point 7. Execute the historic re-attribution under the
     * current dashboard filters. Server-side hard limit 10,000 rows --
     * larger backfills go through scripts/backfill_recon_attribution.py
     * (chunked + retry semantics).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const backfillAttributionPendingMutationVariables = qraft.externalCallsService.backfillAttribution.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const backfillAttributionMutationData = qraft.externalCallsService.backfillAttribution.useMutationState({
     *     filters: {
     *         parameters: {
     *             query: {
     *                 office_id: officeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        BackfillAttributionData,
        OperationError<BackfillAttributionError>,
        MutationVariables<BackfillAttributionBody, BackfillAttributionParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            BackfillAttributionBody,
            BackfillAttributionData,
            BackfillAttributionParameters,
            OperationError<BackfillAttributionError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BackfillAttributionSchema,
            BackfillAttributionBody,
            BackfillAttributionData,
            BackfillAttributionParameters,
            OperationError<BackfillAttributionError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          BackfillAttributionData,
          OperationError<BackfillAttributionError>,
          MutationVariables<BackfillAttributionBody, BackfillAttributionParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Backfill Attribution
     * @description SOL-2636 Point 7. Execute the historic re-attribution under the
     * current dashboard filters. Server-side hard limit 10,000 rows --
     * larger backfills go through scripts/backfill_recon_attribution.py
     * (chunked + retry semantics).
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            BackfillAttributionBody,
            BackfillAttributionData,
            BackfillAttributionParameters,
            OperationError<BackfillAttributionError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BackfillAttributionSchema,
            BackfillAttributionBody,
            BackfillAttributionData,
            BackfillAttributionParameters,
            OperationError<BackfillAttributionError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Backfill Attribution
     * @description SOL-2636 Point 7. Execute the historic re-attribution under the
     * current dashboard filters. Server-side hard limit 10,000 rows --
     * larger backfills go through scripts/backfill_recon_attribution.py
     * (chunked + retry semantics).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.externalCallsService.backfillAttribution.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.externalCallsService.backfillAttribution.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              BackfillAttributionBody,
              BackfillAttributionData,
              BackfillAttributionParameters,
              OperationError<BackfillAttributionError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BackfillAttributionSchema,
              BackfillAttributionBody,
              BackfillAttributionData,
              BackfillAttributionParameters,
              OperationError<BackfillAttributionError>,
              TContext
            >
      ):
        | Mutation<
            BackfillAttributionData,
            BackfillAttributionError,
            MutationVariables<BackfillAttributionBody, BackfillAttributionParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              BackfillAttributionBody,
              BackfillAttributionData,
              BackfillAttributionParameters,
              OperationError<BackfillAttributionError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BackfillAttributionSchema,
              BackfillAttributionBody,
              BackfillAttributionData,
              BackfillAttributionParameters,
              OperationError<BackfillAttributionError>,
              TContext
            >
      ): Array<
        Mutation<
          BackfillAttributionData,
          BackfillAttributionError,
          MutationVariables<BackfillAttributionBody, BackfillAttributionParameters>,
          TContext
        >
      >;
    };
    schema: BackfillAttributionSchema;
    types: {
      parameters: BackfillAttributionParameters;
      data: BackfillAttributionData;
      error: BackfillAttributionError;
      body: BackfillAttributionBody;
    };
  };
  /**
   * @summary Re Eval Preview
   * @description Counts for the Re-eval LLM dialog under the current dashboard
   * filters: the eligible total and the no-analysis subset, both already
   * restricted to the calls the evaluator would actually score.
   */
  reEvalPreview: {
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ReEvalPreviewParameters, TMeta, TSignal> | void),
      client?: (
        schema: ReEvalPreviewSchema,
        options: {
          parameters: ReEvalPreviewParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ReEvalPreviewData, ReEvalPreviewError>>
    ): Promise<RequestFnResponse<ReEvalPreviewData, ReEvalPreviewError>>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    getQueryKey(
      parameters: DeepReadonly<ReEvalPreviewParameters> | void
    ): ServiceOperationQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.reEvalPreview.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.reEvalPreview.useQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useQuery<TData = ReEvalPreviewData>(
      parameters:
        | ServiceOperationQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        | (DeepReadonly<ReEvalPreviewParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ReEvalPreviewData,
          ReEvalPreviewError,
          TData,
          ServiceOperationQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ReEvalPreviewError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.reEvalPreview.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.reEvalPreview.useQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useQuery<TData = ReEvalPreviewData>(
      parameters:
        | ServiceOperationQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        | (DeepReadonly<ReEvalPreviewParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ReEvalPreviewData,
          ReEvalPreviewError,
          TData,
          ServiceOperationQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ReEvalPreviewError>>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ReEvalPreviewParameters> | void
    ): ServiceOperationInfiniteQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.reEvalPreview.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ReEvalPreviewParameters,
      TQueryFnData = ReEvalPreviewData,
      TData = OperationInfiniteData<TQueryFnData, ReEvalPreviewParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        | (DeepReadonly<ReEvalPreviewParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ReEvalPreviewError,
          TData,
          ServiceOperationInfiniteQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ReEvalPreviewError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.reEvalPreview.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ReEvalPreviewParameters,
      TQueryFnData = ReEvalPreviewData,
      TData = OperationInfiniteData<TQueryFnData, ReEvalPreviewParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        | (DeepReadonly<ReEvalPreviewParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ReEvalPreviewError,
          TData,
          ServiceOperationInfiniteQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ReEvalPreviewData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ReEvalPreviewError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const reEvalPreviewTotal = qraft.externalCallsService.reEvalPreview.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const reEvalPreviewByParametersTotal = qraft.externalCallsService.reEvalPreview.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             start_time__gte: startTimeGte
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
        | QueryFiltersByQueryKey<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const reEvalPreviewResults = qraft.externalCallsService.reEvalPreview.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * reEvalPreviewResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const reEvalPreviewCombinedResults = qraft.externalCallsService.reEvalPreview.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * reEvalPreviewCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ReEvalPreviewSchema,
          ReEvalPreviewParameters,
          ReEvalPreviewData,
          ReEvalPreviewError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ReEvalPreviewData, ReEvalPreviewError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ReEvalPreviewData, ReEvalPreviewError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.externalCallsService.reEvalPreview.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.reEvalPreview.useSuspenseQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ReEvalPreviewData>(
      parameters:
        | ServiceOperationQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        | (DeepReadonly<ReEvalPreviewParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ReEvalPreviewData,
          ReEvalPreviewError,
          TData,
          ServiceOperationQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ReEvalPreviewError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.reEvalPreview.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ReEvalPreviewParameters, TData = ReEvalPreviewData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        | (DeepReadonly<ReEvalPreviewParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ReEvalPreviewData,
          ReEvalPreviewError,
          OperationInfiniteData<TData, ReEvalPreviewParameters>,
          ServiceOperationInfiniteQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ReEvalPreviewData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ReEvalPreviewParameters>,
      OperationError<ReEvalPreviewError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const reEvalPreviewData = qraft.externalCallsService.reEvalPreview.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * reEvalPreviewResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const reEvalPreviewCombinedData = qraft.externalCallsService.reEvalPreview.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * reEvalPreviewCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ReEvalPreviewSchema,
          ReEvalPreviewParameters,
          ReEvalPreviewData,
          ReEvalPreviewError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ReEvalPreviewData, ReEvalPreviewError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ReEvalPreviewData, ReEvalPreviewError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ReEvalPreviewSchema,
        ReEvalPreviewData,
        ReEvalPreviewParameters,
        ReEvalPreviewError
      > | void
    ): Promise<ReEvalPreviewData>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ReEvalPreviewSchema,
        ReEvalPreviewData,
        ReEvalPreviewParameters,
        ReEvalPreviewError
      > | void
    ): Promise<void>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ReEvalPreviewSchema,
        ReEvalPreviewData,
        ReEvalPreviewParameters,
        ReEvalPreviewError
      > | void
    ): Promise<ReEvalPreviewData>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    fetchInfiniteQuery<TPageParam extends ReEvalPreviewParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ReEvalPreviewSchema,
        ReEvalPreviewData,
        ReEvalPreviewParameters,
        DeepReadonly<TPageParam>,
        ReEvalPreviewError
      > | void
    ): Promise<OperationInfiniteData<ReEvalPreviewData, ReEvalPreviewParameters>>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    prefetchInfiniteQuery<TPageParam extends ReEvalPreviewParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ReEvalPreviewSchema,
        ReEvalPreviewData,
        ReEvalPreviewParameters,
        DeepReadonly<TPageParam>,
        ReEvalPreviewError
      > | void
    ): Promise<void>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    ensureInfiniteQueryData<TPageParam extends ReEvalPreviewParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ReEvalPreviewSchema,
        ReEvalPreviewData,
        ReEvalPreviewParameters,
        DeepReadonly<TPageParam>,
        ReEvalPreviewError
      > | void
    ): Promise<OperationInfiniteData<ReEvalPreviewData, ReEvalPreviewParameters>>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        | (DeepReadonly<ReEvalPreviewParameters> | void)
    ): ReEvalPreviewData | undefined;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        | (DeepReadonly<ReEvalPreviewParameters> | void)
    ): OperationInfiniteData<ReEvalPreviewData, ReEvalPreviewParameters> | undefined;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
        | QueryFiltersByQueryKey<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>,
            data: NoInfer<OperationInfiniteData<ReEvalPreviewData, ReEvalPreviewParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>,
            data: ReEvalPreviewData | undefined,
          ]
        >;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        | (DeepReadonly<ReEvalPreviewParameters> | void)
    ): QueryState<ReEvalPreviewData, ReEvalPreviewError> | undefined;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ReEvalPreviewParameters>
        | ServiceOperationInfiniteQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>
        | void
    ): QueryState<OperationInfiniteData<ReEvalPreviewData, ReEvalPreviewParameters>, ReEvalPreviewError> | undefined;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<ReEvalPreviewParameters> | undefined)
        | ServiceOperationQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>,
      updater: Updater<NoInfer<ReEvalPreviewData> | undefined, NoInfer<DeepReadonly<ReEvalPreviewData>> | undefined>,
      options?: SetDataOptions
    ): ReEvalPreviewData | undefined;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ReEvalPreviewParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ReEvalPreviewSchema, ReEvalPreviewParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ReEvalPreviewData, ReEvalPreviewParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ReEvalPreviewData, ReEvalPreviewParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ReEvalPreviewData, ReEvalPreviewParameters> | undefined;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
        | QueryFiltersByQueryKey<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >,
      updater: Updater<NoInfer<ReEvalPreviewData> | undefined, NoInfer<ReEvalPreviewData> | undefined>,
      options?: SetDataOptions
    ): Array<ReEvalPreviewData | undefined>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ReEvalPreviewSchema,
        ReEvalPreviewData,
        TInfinite,
        ReEvalPreviewParameters,
        ReEvalPreviewError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
        | QueryFiltersByQueryKey<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
        | QueryFiltersByQueryKey<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
        | QueryFiltersByQueryKey<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
    ): void;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
        | QueryFiltersByQueryKey<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Re Eval Preview
     * @description Counts for the Re-eval LLM dialog under the current dashboard
     * filters: the eligible total and the no-analysis subset, both already
     * restricted to the calls the evaluator would actually score.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
        | QueryFiltersByQueryKey<
            ReEvalPreviewSchema,
            ReEvalPreviewData,
            TInfinite,
            ReEvalPreviewParameters,
            ReEvalPreviewError
          >
    ): number;
    schema: ReEvalPreviewSchema;
    types: {
      parameters: ReEvalPreviewParameters;
      data: ReEvalPreviewData;
      error: ReEvalPreviewError;
    };
  };
  /**
   * @summary Re Eval
   * @description Submit eval jobs for the eligible calls under the current filters.
   * `include_already_evaluated=false` re-evaluates calls with no analysis yet
   * plus calls pinned to a retired metric version (ADR-023); `true` also
   * re-scores calls that already have a current one.
   * Hard limit 10,000 -> 409 too_large.
   */
  reEval: {
    /**
     * @summary Re Eval
     * @description Submit eval jobs for the eligible calls under the current filters.
     * `include_already_evaluated=false` re-evaluates calls with no analysis yet
     * plus calls pinned to a retired metric version (ADR-023); `true` also
     * re-scores calls that already have a current one.
     * Hard limit 10,000 -> 409 too_large.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<ReEvalBody, ReEvalParameters, TMeta, TSignal>,
      client?: (
        schema: ReEvalSchema,
        options: ServiceOperationMutationFnOptions<ReEvalBody, ReEvalParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<ReEvalData, ReEvalError>>
    ): Promise<RequestFnResponse<ReEvalData, ReEvalError>>;
    /**
     * @summary Re Eval
     * @description Submit eval jobs for the eligible calls under the current filters.
     * `include_already_evaluated=false` re-evaluates calls with no analysis yet
     * plus calls pinned to a retired metric version (ADR-023); `true` also
     * re-scores calls that already have a current one.
     * Hard limit 10,000 -> 409 too_large.
     */
    getMutationKey(
      parameters: DeepReadonly<ReEvalParameters> | void
    ): ServiceOperationMutationKey<ReEvalSchema, ReEvalParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Re Eval
     * @description Submit eval jobs for the eligible calls under the current filters.
     * `include_already_evaluated=false` re-evaluates calls with no analysis yet
     * plus calls pinned to a retired metric version (ADR-023); `true` also
     * re-scores calls that already have a current one.
     * Hard limit 10,000 -> 409 too_large.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.reEval.useMutation({
     *     query: {
     *         include_already_evaluated: includeAlreadyEvaluated
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.reEval.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         include_already_evaluated: includeAlreadyEvaluated
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends ReEvalBody, TContext = unknown>(
      parameters: DeepReadonly<ReEvalParameters>,
      options?: ServiceOperationUseMutationOptions<
        ReEvalSchema,
        ReEvalData,
        ReEvalParameters,
        TVariables,
        OperationError<ReEvalError>,
        TContext
      >
    ): UseMutationResult<ReEvalData, OperationError<ReEvalError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Re Eval
     * @description Submit eval jobs for the eligible calls under the current filters.
     * `include_already_evaluated=false` re-evaluates calls with no analysis yet
     * plus calls pinned to a retired metric version (ADR-023); `true` also
     * re-scores calls that already have a current one.
     * Hard limit 10,000 -> 409 too_large.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.reEval.useMutation({
     *     query: {
     *         include_already_evaluated: includeAlreadyEvaluated
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.reEval.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         include_already_evaluated: includeAlreadyEvaluated
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<ReEvalBody, ReEvalParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ReEvalSchema,
        ReEvalData,
        ReEvalParameters,
        TVariables,
        OperationError<ReEvalError>,
        TContext
      >
    ): UseMutationResult<ReEvalData, OperationError<ReEvalError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Re Eval
     * @description Submit eval jobs for the eligible calls under the current filters.
     * `include_already_evaluated=false` re-evaluates calls with no analysis yet
     * plus calls pinned to a retired metric version (ADR-023); `true` also
     * re-scores calls that already have a current one.
     * Hard limit 10,000 -> 409 too_large.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const reEvalTotal = qraft.externalCallsService.reEval.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const reEvalTotal = qraft.externalCallsService.reEval.useIsMutating({
     *     parameters: {
     *         query: {
     *             include_already_evaluated: includeAlreadyEvaluated
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<ReEvalBody, ReEvalData, ReEvalParameters, OperationError<ReEvalError>, TContext>
        | MutationFiltersByMutationKey<
            ReEvalSchema,
            ReEvalBody,
            ReEvalData,
            ReEvalParameters,
            OperationError<ReEvalError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Re Eval
     * @description Submit eval jobs for the eligible calls under the current filters.
     * `include_already_evaluated=false` re-evaluates calls with no analysis yet
     * plus calls pinned to a retired metric version (ADR-023); `true` also
     * re-scores calls that already have a current one.
     * Hard limit 10,000 -> 409 too_large.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const reEvalPendingMutationVariables = qraft.externalCallsService.reEval.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const reEvalMutationData = qraft.externalCallsService.reEval.useMutationState({
     *     filters: {
     *         parameters: {
     *             query: {
     *                 include_already_evaluated: includeAlreadyEvaluated
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ReEvalData,
        OperationError<ReEvalError>,
        MutationVariables<ReEvalBody, ReEvalParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<ReEvalBody, ReEvalData, ReEvalParameters, OperationError<ReEvalError>, TContext>
        | MutationFiltersByMutationKey<
            ReEvalSchema,
            ReEvalBody,
            ReEvalData,
            ReEvalParameters,
            OperationError<ReEvalError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ReEvalData,
          OperationError<ReEvalError>,
          MutationVariables<ReEvalBody, ReEvalParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Re Eval
     * @description Submit eval jobs for the eligible calls under the current filters.
     * `include_already_evaluated=false` re-evaluates calls with no analysis yet
     * plus calls pinned to a retired metric version (ADR-023); `true` also
     * re-scores calls that already have a current one.
     * Hard limit 10,000 -> 409 too_large.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<ReEvalBody, ReEvalData, ReEvalParameters, OperationError<ReEvalError>, TContext>
        | MutationFiltersByMutationKey<
            ReEvalSchema,
            ReEvalBody,
            ReEvalData,
            ReEvalParameters,
            OperationError<ReEvalError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Re Eval
     * @description Submit eval jobs for the eligible calls under the current filters.
     * `include_already_evaluated=false` re-evaluates calls with no analysis yet
     * plus calls pinned to a retired metric version (ADR-023); `true` also
     * re-scores calls that already have a current one.
     * Hard limit 10,000 -> 409 too_large.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.externalCallsService.reEval.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         query: {
     *             include_already_evaluated: includeAlreadyEvaluated
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.externalCallsService.reEval.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<ReEvalBody, ReEvalData, ReEvalParameters, OperationError<ReEvalError>, TContext>
          | MutationFiltersByMutationKey<
              ReEvalSchema,
              ReEvalBody,
              ReEvalData,
              ReEvalParameters,
              OperationError<ReEvalError>,
              TContext
            >
      ): Mutation<ReEvalData, ReEvalError, MutationVariables<ReEvalBody, ReEvalParameters>, TContext> | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<ReEvalBody, ReEvalData, ReEvalParameters, OperationError<ReEvalError>, TContext>
          | MutationFiltersByMutationKey<
              ReEvalSchema,
              ReEvalBody,
              ReEvalData,
              ReEvalParameters,
              OperationError<ReEvalError>,
              TContext
            >
      ): Array<Mutation<ReEvalData, ReEvalError, MutationVariables<ReEvalBody, ReEvalParameters>, TContext>>;
    };
    schema: ReEvalSchema;
    types: {
      parameters: ReEvalParameters;
      data: ReEvalData;
      error: ReEvalError;
      body: ReEvalBody;
    };
  };
  /**
   * @summary Recompute Scores Preview
   * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
   * filters: how many scored calls are in scope, whether the office has recompute history,
   * and which metrics would change (rules differ vs the version they were scored under).
   */
  recomputeScoresPreview: {
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<RecomputeScoresPreviewParameters, TMeta, TSignal> | void),
      client?: (
        schema: RecomputeScoresPreviewSchema,
        options: {
          parameters: RecomputeScoresPreviewParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<RecomputeScoresPreviewData, RecomputeScoresPreviewError>>
    ): Promise<RequestFnResponse<RecomputeScoresPreviewData, RecomputeScoresPreviewError>>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    getQueryKey(
      parameters: DeepReadonly<RecomputeScoresPreviewParameters> | void
    ): ServiceOperationQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.recomputeScoresPreview.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.recomputeScoresPreview.useQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useQuery<TData = RecomputeScoresPreviewData>(
      parameters:
        | ServiceOperationQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        | (DeepReadonly<RecomputeScoresPreviewParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          RecomputeScoresPreviewData,
          RecomputeScoresPreviewError,
          TData,
          ServiceOperationQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<RecomputeScoresPreviewError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.recomputeScoresPreview.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.recomputeScoresPreview.useQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useQuery<TData = RecomputeScoresPreviewData>(
      parameters:
        | ServiceOperationQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        | (DeepReadonly<RecomputeScoresPreviewParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          RecomputeScoresPreviewData,
          RecomputeScoresPreviewError,
          TData,
          ServiceOperationQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<RecomputeScoresPreviewError>>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<RecomputeScoresPreviewParameters> | void
    ): ServiceOperationInfiniteQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.recomputeScoresPreview.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends RecomputeScoresPreviewParameters,
      TQueryFnData = RecomputeScoresPreviewData,
      TData = OperationInfiniteData<TQueryFnData, RecomputeScoresPreviewParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        | (DeepReadonly<RecomputeScoresPreviewParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          RecomputeScoresPreviewError,
          TData,
          ServiceOperationInfiniteQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<RecomputeScoresPreviewError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.recomputeScoresPreview.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends RecomputeScoresPreviewParameters,
      TQueryFnData = RecomputeScoresPreviewData,
      TData = OperationInfiniteData<TQueryFnData, RecomputeScoresPreviewParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        | (DeepReadonly<RecomputeScoresPreviewParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          RecomputeScoresPreviewError,
          TData,
          ServiceOperationInfiniteQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<RecomputeScoresPreviewData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<RecomputeScoresPreviewError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const recomputeScoresPreviewTotal = qraft.externalCallsService.recomputeScoresPreview.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const recomputeScoresPreviewByParametersTotal = qraft.externalCallsService.recomputeScoresPreview.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             start_time__gte: startTimeGte
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
        | QueryFiltersByQueryKey<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const recomputeScoresPreviewResults = qraft.externalCallsService.recomputeScoresPreview.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * recomputeScoresPreviewResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const recomputeScoresPreviewCombinedResults = qraft.externalCallsService.recomputeScoresPreview.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * recomputeScoresPreviewCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          RecomputeScoresPreviewSchema,
          RecomputeScoresPreviewParameters,
          RecomputeScoresPreviewData,
          RecomputeScoresPreviewError
        >
      >,
      TCombinedResult = Array<UseQueryResult<RecomputeScoresPreviewData, RecomputeScoresPreviewError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<RecomputeScoresPreviewData, RecomputeScoresPreviewError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.externalCallsService.recomputeScoresPreview.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.recomputeScoresPreview.useSuspenseQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = RecomputeScoresPreviewData>(
      parameters:
        | ServiceOperationQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        | (DeepReadonly<RecomputeScoresPreviewParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          RecomputeScoresPreviewData,
          RecomputeScoresPreviewError,
          TData,
          ServiceOperationQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<RecomputeScoresPreviewError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.recomputeScoresPreview.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends RecomputeScoresPreviewParameters, TData = RecomputeScoresPreviewData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        | (DeepReadonly<RecomputeScoresPreviewParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          RecomputeScoresPreviewData,
          RecomputeScoresPreviewError,
          OperationInfiniteData<TData, RecomputeScoresPreviewParameters>,
          ServiceOperationInfiniteQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<RecomputeScoresPreviewData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, RecomputeScoresPreviewParameters>,
      OperationError<RecomputeScoresPreviewError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const recomputeScoresPreviewData = qraft.externalCallsService.recomputeScoresPreview.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * recomputeScoresPreviewResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const recomputeScoresPreviewCombinedData = qraft.externalCallsService.recomputeScoresPreview.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * recomputeScoresPreviewCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          RecomputeScoresPreviewSchema,
          RecomputeScoresPreviewParameters,
          RecomputeScoresPreviewData,
          RecomputeScoresPreviewError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<RecomputeScoresPreviewData, RecomputeScoresPreviewError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<RecomputeScoresPreviewData, RecomputeScoresPreviewError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        RecomputeScoresPreviewSchema,
        RecomputeScoresPreviewData,
        RecomputeScoresPreviewParameters,
        RecomputeScoresPreviewError
      > | void
    ): Promise<RecomputeScoresPreviewData>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        RecomputeScoresPreviewSchema,
        RecomputeScoresPreviewData,
        RecomputeScoresPreviewParameters,
        RecomputeScoresPreviewError
      > | void
    ): Promise<void>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        RecomputeScoresPreviewSchema,
        RecomputeScoresPreviewData,
        RecomputeScoresPreviewParameters,
        RecomputeScoresPreviewError
      > | void
    ): Promise<RecomputeScoresPreviewData>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    fetchInfiniteQuery<TPageParam extends RecomputeScoresPreviewParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        RecomputeScoresPreviewSchema,
        RecomputeScoresPreviewData,
        RecomputeScoresPreviewParameters,
        DeepReadonly<TPageParam>,
        RecomputeScoresPreviewError
      > | void
    ): Promise<OperationInfiniteData<RecomputeScoresPreviewData, RecomputeScoresPreviewParameters>>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    prefetchInfiniteQuery<TPageParam extends RecomputeScoresPreviewParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        RecomputeScoresPreviewSchema,
        RecomputeScoresPreviewData,
        RecomputeScoresPreviewParameters,
        DeepReadonly<TPageParam>,
        RecomputeScoresPreviewError
      > | void
    ): Promise<void>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    ensureInfiniteQueryData<TPageParam extends RecomputeScoresPreviewParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        RecomputeScoresPreviewSchema,
        RecomputeScoresPreviewData,
        RecomputeScoresPreviewParameters,
        DeepReadonly<TPageParam>,
        RecomputeScoresPreviewError
      > | void
    ): Promise<OperationInfiniteData<RecomputeScoresPreviewData, RecomputeScoresPreviewParameters>>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        | (DeepReadonly<RecomputeScoresPreviewParameters> | void)
    ): RecomputeScoresPreviewData | undefined;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        | (DeepReadonly<RecomputeScoresPreviewParameters> | void)
    ): OperationInfiniteData<RecomputeScoresPreviewData, RecomputeScoresPreviewParameters> | undefined;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
        | QueryFiltersByQueryKey<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>,
            data:
              | NoInfer<OperationInfiniteData<RecomputeScoresPreviewData, RecomputeScoresPreviewParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>,
            data: RecomputeScoresPreviewData | undefined,
          ]
        >;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        | (DeepReadonly<RecomputeScoresPreviewParameters> | void)
    ): QueryState<RecomputeScoresPreviewData, RecomputeScoresPreviewError> | undefined;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<RecomputeScoresPreviewParameters>
        | ServiceOperationInfiniteQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<RecomputeScoresPreviewData, RecomputeScoresPreviewParameters>,
          RecomputeScoresPreviewError
        >
      | undefined;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    setQueryData(
      parameters:
        | (DeepReadonly<RecomputeScoresPreviewParameters> | undefined)
        | ServiceOperationQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>,
      updater: Updater<
        NoInfer<RecomputeScoresPreviewData> | undefined,
        NoInfer<DeepReadonly<RecomputeScoresPreviewData>> | undefined
      >,
      options?: SetDataOptions
    ): RecomputeScoresPreviewData | undefined;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<RecomputeScoresPreviewParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<RecomputeScoresPreviewSchema, RecomputeScoresPreviewParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<RecomputeScoresPreviewData, RecomputeScoresPreviewParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<RecomputeScoresPreviewData, RecomputeScoresPreviewParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<RecomputeScoresPreviewData, RecomputeScoresPreviewParameters> | undefined;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
        | QueryFiltersByQueryKey<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >,
      updater: Updater<
        NoInfer<RecomputeScoresPreviewData> | undefined,
        NoInfer<RecomputeScoresPreviewData> | undefined
      >,
      options?: SetDataOptions
    ): Array<RecomputeScoresPreviewData | undefined>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        RecomputeScoresPreviewSchema,
        RecomputeScoresPreviewData,
        TInfinite,
        RecomputeScoresPreviewParameters,
        RecomputeScoresPreviewError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
        | QueryFiltersByQueryKey<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
        | QueryFiltersByQueryKey<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
        | QueryFiltersByQueryKey<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
    ): void;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
        | QueryFiltersByQueryKey<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Recompute Scores Preview
     * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
     * filters: how many scored calls are in scope, whether the office has recompute history,
     * and which metrics would change (rules differ vs the version they were scored under).
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
        | QueryFiltersByQueryKey<
            RecomputeScoresPreviewSchema,
            RecomputeScoresPreviewData,
            TInfinite,
            RecomputeScoresPreviewParameters,
            RecomputeScoresPreviewError
          >
    ): number;
    schema: RecomputeScoresPreviewSchema;
    types: {
      parameters: RecomputeScoresPreviewParameters;
      data: RecomputeScoresPreviewData;
      error: RecomputeScoresPreviewError;
    };
  };
  /**
   * @summary Recompute Scores
   * @description SOL-2636 Issue 2. Re-aggregate call_avg_score for the scoped calls under
   * latest-active rules. Writes only call_avg_score; never re-runs the LLM. Hard limit
   * 10,000 (larger runs go through the CLI dispatcher).
   */
  recomputeScores: {
    /**
     * @summary Recompute Scores
     * @description SOL-2636 Issue 2. Re-aggregate call_avg_score for the scoped calls under
     * latest-active rules. Writes only call_avg_score; never re-runs the LLM. Hard limit
     * 10,000 (larger runs go through the CLI dispatcher).
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<RecomputeScoresBody, RecomputeScoresParameters, TMeta, TSignal>,
      client?: (
        schema: RecomputeScoresSchema,
        options: ServiceOperationMutationFnOptions<RecomputeScoresBody, RecomputeScoresParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<RecomputeScoresData, RecomputeScoresError>>
    ): Promise<RequestFnResponse<RecomputeScoresData, RecomputeScoresError>>;
    /**
     * @summary Recompute Scores
     * @description SOL-2636 Issue 2. Re-aggregate call_avg_score for the scoped calls under
     * latest-active rules. Writes only call_avg_score; never re-runs the LLM. Hard limit
     * 10,000 (larger runs go through the CLI dispatcher).
     */
    getMutationKey(
      parameters: DeepReadonly<RecomputeScoresParameters> | void
    ): ServiceOperationMutationKey<RecomputeScoresSchema, RecomputeScoresParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Recompute Scores
     * @description SOL-2636 Issue 2. Re-aggregate call_avg_score for the scoped calls under
     * latest-active rules. Writes only call_avg_score; never re-runs the LLM. Hard limit
     * 10,000 (larger runs go through the CLI dispatcher).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.recomputeScores.useMutation({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.recomputeScores.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends RecomputeScoresBody, TContext = unknown>(
      parameters: DeepReadonly<RecomputeScoresParameters>,
      options?: ServiceOperationUseMutationOptions<
        RecomputeScoresSchema,
        RecomputeScoresData,
        RecomputeScoresParameters,
        TVariables,
        OperationError<RecomputeScoresError>,
        TContext
      >
    ): UseMutationResult<RecomputeScoresData, OperationError<RecomputeScoresError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Recompute Scores
     * @description SOL-2636 Issue 2. Re-aggregate call_avg_score for the scoped calls under
     * latest-active rules. Writes only call_avg_score; never re-runs the LLM. Hard limit
     * 10,000 (larger runs go through the CLI dispatcher).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.recomputeScores.useMutation({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.recomputeScores.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<RecomputeScoresBody, RecomputeScoresParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RecomputeScoresSchema,
        RecomputeScoresData,
        RecomputeScoresParameters,
        TVariables,
        OperationError<RecomputeScoresError>,
        TContext
      >
    ): UseMutationResult<RecomputeScoresData, OperationError<RecomputeScoresError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Recompute Scores
     * @description SOL-2636 Issue 2. Re-aggregate call_avg_score for the scoped calls under
     * latest-active rules. Writes only call_avg_score; never re-runs the LLM. Hard limit
     * 10,000 (larger runs go through the CLI dispatcher).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const recomputeScoresTotal = qraft.externalCallsService.recomputeScores.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const recomputeScoresTotal = qraft.externalCallsService.recomputeScores.useIsMutating({
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RecomputeScoresBody,
            RecomputeScoresData,
            RecomputeScoresParameters,
            OperationError<RecomputeScoresError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RecomputeScoresSchema,
            RecomputeScoresBody,
            RecomputeScoresData,
            RecomputeScoresParameters,
            OperationError<RecomputeScoresError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Recompute Scores
     * @description SOL-2636 Issue 2. Re-aggregate call_avg_score for the scoped calls under
     * latest-active rules. Writes only call_avg_score; never re-runs the LLM. Hard limit
     * 10,000 (larger runs go through the CLI dispatcher).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const recomputeScoresPendingMutationVariables = qraft.externalCallsService.recomputeScores.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const recomputeScoresMutationData = qraft.externalCallsService.recomputeScores.useMutationState({
     *     filters: {
     *         parameters: {
     *             query: {
     *                 office_id: officeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RecomputeScoresData,
        OperationError<RecomputeScoresError>,
        MutationVariables<RecomputeScoresBody, RecomputeScoresParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RecomputeScoresBody,
            RecomputeScoresData,
            RecomputeScoresParameters,
            OperationError<RecomputeScoresError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RecomputeScoresSchema,
            RecomputeScoresBody,
            RecomputeScoresData,
            RecomputeScoresParameters,
            OperationError<RecomputeScoresError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RecomputeScoresData,
          OperationError<RecomputeScoresError>,
          MutationVariables<RecomputeScoresBody, RecomputeScoresParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Recompute Scores
     * @description SOL-2636 Issue 2. Re-aggregate call_avg_score for the scoped calls under
     * latest-active rules. Writes only call_avg_score; never re-runs the LLM. Hard limit
     * 10,000 (larger runs go through the CLI dispatcher).
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RecomputeScoresBody,
            RecomputeScoresData,
            RecomputeScoresParameters,
            OperationError<RecomputeScoresError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RecomputeScoresSchema,
            RecomputeScoresBody,
            RecomputeScoresData,
            RecomputeScoresParameters,
            OperationError<RecomputeScoresError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Recompute Scores
     * @description SOL-2636 Issue 2. Re-aggregate call_avg_score for the scoped calls under
     * latest-active rules. Writes only call_avg_score; never re-runs the LLM. Hard limit
     * 10,000 (larger runs go through the CLI dispatcher).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.externalCallsService.recomputeScores.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.externalCallsService.recomputeScores.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RecomputeScoresBody,
              RecomputeScoresData,
              RecomputeScoresParameters,
              OperationError<RecomputeScoresError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RecomputeScoresSchema,
              RecomputeScoresBody,
              RecomputeScoresData,
              RecomputeScoresParameters,
              OperationError<RecomputeScoresError>,
              TContext
            >
      ):
        | Mutation<
            RecomputeScoresData,
            RecomputeScoresError,
            MutationVariables<RecomputeScoresBody, RecomputeScoresParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RecomputeScoresBody,
              RecomputeScoresData,
              RecomputeScoresParameters,
              OperationError<RecomputeScoresError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RecomputeScoresSchema,
              RecomputeScoresBody,
              RecomputeScoresData,
              RecomputeScoresParameters,
              OperationError<RecomputeScoresError>,
              TContext
            >
      ): Array<
        Mutation<
          RecomputeScoresData,
          RecomputeScoresError,
          MutationVariables<RecomputeScoresBody, RecomputeScoresParameters>,
          TContext
        >
      >;
    };
    schema: RecomputeScoresSchema;
    types: {
      parameters: RecomputeScoresParameters;
      data: RecomputeScoresData;
      error: RecomputeScoresError;
      body: RecomputeScoresBody;
    };
  };
  /**
   * @summary Metrics Version Spread
   * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
   * span and what the current version is — drives the "Edited this period" chip. Read-only.
   *
   * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
   * informational read that feeds the same dashboard view as the (non-admin) call-stats
   * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
   * Office-scoped via the pin check below.
   */
  metricsVersionSpread: {
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<MetricsVersionSpreadParameters, TMeta, TSignal> | void),
      client?: (
        schema: MetricsVersionSpreadSchema,
        options: {
          parameters: MetricsVersionSpreadParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<MetricsVersionSpreadData, MetricsVersionSpreadError>>
    ): Promise<RequestFnResponse<MetricsVersionSpreadData, MetricsVersionSpreadError>>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    getQueryKey(
      parameters: DeepReadonly<MetricsVersionSpreadParameters> | void
    ): ServiceOperationQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.metricsVersionSpread.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.metricsVersionSpread.useQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useQuery<TData = MetricsVersionSpreadData>(
      parameters:
        | ServiceOperationQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        | (DeepReadonly<MetricsVersionSpreadParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          MetricsVersionSpreadData,
          MetricsVersionSpreadError,
          TData,
          ServiceOperationQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<MetricsVersionSpreadError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.metricsVersionSpread.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.metricsVersionSpread.useQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useQuery<TData = MetricsVersionSpreadData>(
      parameters:
        | ServiceOperationQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        | (DeepReadonly<MetricsVersionSpreadParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          MetricsVersionSpreadData,
          MetricsVersionSpreadError,
          TData,
          ServiceOperationQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<MetricsVersionSpreadError>>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<MetricsVersionSpreadParameters> | void
    ): ServiceOperationInfiniteQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.metricsVersionSpread.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MetricsVersionSpreadParameters,
      TQueryFnData = MetricsVersionSpreadData,
      TData = OperationInfiniteData<TQueryFnData, MetricsVersionSpreadParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        | (DeepReadonly<MetricsVersionSpreadParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MetricsVersionSpreadError,
          TData,
          ServiceOperationInfiniteQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<MetricsVersionSpreadError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.metricsVersionSpread.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MetricsVersionSpreadParameters,
      TQueryFnData = MetricsVersionSpreadData,
      TData = OperationInfiniteData<TQueryFnData, MetricsVersionSpreadParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        | (DeepReadonly<MetricsVersionSpreadParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MetricsVersionSpreadError,
          TData,
          ServiceOperationInfiniteQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<MetricsVersionSpreadData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<MetricsVersionSpreadError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const metricsVersionSpreadTotal = qraft.externalCallsService.metricsVersionSpread.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const metricsVersionSpreadByParametersTotal = qraft.externalCallsService.metricsVersionSpread.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             start_time__gte: startTimeGte
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
        | QueryFiltersByQueryKey<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const metricsVersionSpreadResults = qraft.externalCallsService.metricsVersionSpread.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * metricsVersionSpreadResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const metricsVersionSpreadCombinedResults = qraft.externalCallsService.metricsVersionSpread.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * metricsVersionSpreadCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          MetricsVersionSpreadSchema,
          MetricsVersionSpreadParameters,
          MetricsVersionSpreadData,
          MetricsVersionSpreadError
        >
      >,
      TCombinedResult = Array<UseQueryResult<MetricsVersionSpreadData, MetricsVersionSpreadError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<MetricsVersionSpreadData, MetricsVersionSpreadError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.externalCallsService.metricsVersionSpread.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.metricsVersionSpread.useSuspenseQuery({
     *     query: {
     *         start_time__gte: startTimeGte
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = MetricsVersionSpreadData>(
      parameters:
        | ServiceOperationQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        | (DeepReadonly<MetricsVersionSpreadParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          MetricsVersionSpreadData,
          MetricsVersionSpreadError,
          TData,
          ServiceOperationQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<MetricsVersionSpreadError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.metricsVersionSpread.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_time__gte: initialStartTimeGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends MetricsVersionSpreadParameters, TData = MetricsVersionSpreadData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        | (DeepReadonly<MetricsVersionSpreadParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          MetricsVersionSpreadData,
          MetricsVersionSpreadError,
          OperationInfiniteData<TData, MetricsVersionSpreadParameters>,
          ServiceOperationInfiniteQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<MetricsVersionSpreadData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, MetricsVersionSpreadParameters>,
      OperationError<MetricsVersionSpreadError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const metricsVersionSpreadData = qraft.externalCallsService.metricsVersionSpread.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * metricsVersionSpreadResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const metricsVersionSpreadCombinedData = qraft.externalCallsService.metricsVersionSpread.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_time__gte: startTimeGte2
     *             }
     *         }
     *     ]
     * });
     * metricsVersionSpreadCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          MetricsVersionSpreadSchema,
          MetricsVersionSpreadParameters,
          MetricsVersionSpreadData,
          MetricsVersionSpreadError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<MetricsVersionSpreadData, MetricsVersionSpreadError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<MetricsVersionSpreadData, MetricsVersionSpreadError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MetricsVersionSpreadSchema,
        MetricsVersionSpreadData,
        MetricsVersionSpreadParameters,
        MetricsVersionSpreadError
      > | void
    ): Promise<MetricsVersionSpreadData>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MetricsVersionSpreadSchema,
        MetricsVersionSpreadData,
        MetricsVersionSpreadParameters,
        MetricsVersionSpreadError
      > | void
    ): Promise<void>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        MetricsVersionSpreadSchema,
        MetricsVersionSpreadData,
        MetricsVersionSpreadParameters,
        MetricsVersionSpreadError
      > | void
    ): Promise<MetricsVersionSpreadData>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    fetchInfiniteQuery<TPageParam extends MetricsVersionSpreadParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MetricsVersionSpreadSchema,
        MetricsVersionSpreadData,
        MetricsVersionSpreadParameters,
        DeepReadonly<TPageParam>,
        MetricsVersionSpreadError
      > | void
    ): Promise<OperationInfiniteData<MetricsVersionSpreadData, MetricsVersionSpreadParameters>>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    prefetchInfiniteQuery<TPageParam extends MetricsVersionSpreadParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MetricsVersionSpreadSchema,
        MetricsVersionSpreadData,
        MetricsVersionSpreadParameters,
        DeepReadonly<TPageParam>,
        MetricsVersionSpreadError
      > | void
    ): Promise<void>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    ensureInfiniteQueryData<TPageParam extends MetricsVersionSpreadParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        MetricsVersionSpreadSchema,
        MetricsVersionSpreadData,
        MetricsVersionSpreadParameters,
        DeepReadonly<TPageParam>,
        MetricsVersionSpreadError
      > | void
    ): Promise<OperationInfiniteData<MetricsVersionSpreadData, MetricsVersionSpreadParameters>>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        | (DeepReadonly<MetricsVersionSpreadParameters> | void)
    ): MetricsVersionSpreadData | undefined;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        | (DeepReadonly<MetricsVersionSpreadParameters> | void)
    ): OperationInfiniteData<MetricsVersionSpreadData, MetricsVersionSpreadParameters> | undefined;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
        | QueryFiltersByQueryKey<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>,
            data: NoInfer<OperationInfiniteData<MetricsVersionSpreadData, MetricsVersionSpreadParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>,
            data: MetricsVersionSpreadData | undefined,
          ]
        >;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        | (DeepReadonly<MetricsVersionSpreadParameters> | void)
    ): QueryState<MetricsVersionSpreadData, MetricsVersionSpreadError> | undefined;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<MetricsVersionSpreadParameters>
        | ServiceOperationInfiniteQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<MetricsVersionSpreadData, MetricsVersionSpreadParameters>,
          MetricsVersionSpreadError
        >
      | undefined;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<MetricsVersionSpreadParameters> | undefined)
        | ServiceOperationQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>,
      updater: Updater<
        NoInfer<MetricsVersionSpreadData> | undefined,
        NoInfer<DeepReadonly<MetricsVersionSpreadData>> | undefined
      >,
      options?: SetDataOptions
    ): MetricsVersionSpreadData | undefined;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<MetricsVersionSpreadParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<MetricsVersionSpreadSchema, MetricsVersionSpreadParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<MetricsVersionSpreadData, MetricsVersionSpreadParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<MetricsVersionSpreadData, MetricsVersionSpreadParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<MetricsVersionSpreadData, MetricsVersionSpreadParameters> | undefined;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
        | QueryFiltersByQueryKey<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >,
      updater: Updater<NoInfer<MetricsVersionSpreadData> | undefined, NoInfer<MetricsVersionSpreadData> | undefined>,
      options?: SetDataOptions
    ): Array<MetricsVersionSpreadData | undefined>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        MetricsVersionSpreadSchema,
        MetricsVersionSpreadData,
        TInfinite,
        MetricsVersionSpreadParameters,
        MetricsVersionSpreadError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
        | QueryFiltersByQueryKey<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
        | QueryFiltersByQueryKey<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
        | QueryFiltersByQueryKey<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
    ): void;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
        | QueryFiltersByQueryKey<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Metrics Version Spread
     * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
     * span and what the current version is — drives the "Edited this period" chip. Read-only.
     *
     * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
     * informational read that feeds the same dashboard view as the (non-admin) call-stats
     * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
     * Office-scoped via the pin check below.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
        | QueryFiltersByQueryKey<
            MetricsVersionSpreadSchema,
            MetricsVersionSpreadData,
            TInfinite,
            MetricsVersionSpreadParameters,
            MetricsVersionSpreadError
          >
    ): number;
    schema: MetricsVersionSpreadSchema;
    types: {
      parameters: MetricsVersionSpreadParameters;
      data: MetricsVersionSpreadData;
      error: MetricsVersionSpreadError;
    };
  };
  /**
   * @summary Get By Id
   * @description Fetch a single external call by its ID.
   */
  getByIdExternalCallsExternalCallIdGet: {
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetByIdExternalCallsExternalCallIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetByIdExternalCallsExternalCallIdGetSchema,
        options: {
          parameters: GetByIdExternalCallsExternalCallIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError>
      >
    ): Promise<
      RequestFnResponse<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError>
    >;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
    ): ServiceOperationQueryKey<
      GetByIdExternalCallsExternalCallIdGetSchema,
      GetByIdExternalCallsExternalCallIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetByIdExternalCallsExternalCallIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetByIdExternalCallsExternalCallIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetByIdExternalCallsExternalCallIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetByIdExternalCallsExternalCallIdGetError>>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetByIdExternalCallsExternalCallIdGetSchema,
      GetByIdExternalCallsExternalCallIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters,
      TQueryFnData = GetByIdExternalCallsExternalCallIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetByIdExternalCallsExternalCallIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetByIdExternalCallsExternalCallIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetByIdExternalCallsExternalCallIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters,
      TQueryFnData = GetByIdExternalCallsExternalCallIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetByIdExternalCallsExternalCallIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetByIdExternalCallsExternalCallIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetByIdExternalCallsExternalCallIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetTotal = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetByParametersTotal = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             external_call_id: externalCallId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetResults = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2
     *             }
     *         }
     *     ]
     * });
     * getByIdExternalCallsExternalCallIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetCombinedResults = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2
     *             }
     *         }
     *     ]
     * });
     * getByIdExternalCallsExternalCallIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetByIdExternalCallsExternalCallIdGetSchema,
          GetByIdExternalCallsExternalCallIdGetParameters,
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useSuspenseQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetByIdExternalCallsExternalCallIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetByIdExternalCallsExternalCallIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters,
      TData = GetByIdExternalCallsExternalCallIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError,
          OperationInfiniteData<TData, GetByIdExternalCallsExternalCallIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetByIdExternalCallsExternalCallIdGetParameters>,
      OperationError<GetByIdExternalCallsExternalCallIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetData = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2
     *             }
     *         }
     *     ]
     * });
     * getByIdExternalCallsExternalCallIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetCombinedData = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2
     *             }
     *         }
     *     ]
     * });
     * getByIdExternalCallsExternalCallIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetByIdExternalCallsExternalCallIdGetSchema,
          GetByIdExternalCallsExternalCallIdGetParameters,
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetByIdExternalCallsExternalCallIdGetData,
              GetByIdExternalCallsExternalCallIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<GetByIdExternalCallsExternalCallIdGetData>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<GetByIdExternalCallsExternalCallIdGetData>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    fetchInfiniteQuery<TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<
      OperationInfiniteData<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetParameters>
    >;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<
      OperationInfiniteData<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetParameters>
    >;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
    ): GetByIdExternalCallsExternalCallIdGetData | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
    ):
      | OperationInfiniteData<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetParameters
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetByIdExternalCallsExternalCallIdGetSchema,
              GetByIdExternalCallsExternalCallIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetByIdExternalCallsExternalCallIdGetData,
                    GetByIdExternalCallsExternalCallIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetByIdExternalCallsExternalCallIdGetSchema,
              GetByIdExternalCallsExternalCallIdGetParameters
            >,
            data: GetByIdExternalCallsExternalCallIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
    ): QueryState<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError> | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetByIdExternalCallsExternalCallIdGetData,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
          GetByIdExternalCallsExternalCallIdGetError
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetByIdExternalCallsExternalCallIdGetData> | undefined,
        NoInfer<DeepReadonly<GetByIdExternalCallsExternalCallIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetByIdExternalCallsExternalCallIdGetData | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetByIdExternalCallsExternalCallIdGetData,
              GetByIdExternalCallsExternalCallIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetByIdExternalCallsExternalCallIdGetData,
                GetByIdExternalCallsExternalCallIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetParameters
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >,
      updater: Updater<
        NoInfer<GetByIdExternalCallsExternalCallIdGetData> | undefined,
        NoInfer<GetByIdExternalCallsExternalCallIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetByIdExternalCallsExternalCallIdGetData | undefined>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        TInfinite,
        GetByIdExternalCallsExternalCallIdGetParameters,
        GetByIdExternalCallsExternalCallIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
    ): void;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
    ): number;
    schema: GetByIdExternalCallsExternalCallIdGetSchema;
    types: {
      parameters: GetByIdExternalCallsExternalCallIdGetParameters;
      data: GetByIdExternalCallsExternalCallIdGetData;
      error: GetByIdExternalCallsExternalCallIdGetError;
    };
  };
  /**
   * @summary Get Distinct Values
   * @description Return distinct values for a given ExternalCall field for the provided office.
   */
  getDistinctValuesExternalCallsDistinctValuesFieldNameGet: {
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            TMeta,
            TSignal
          >,
      client?: (
        schema: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        options: {
          parameters: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    >;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getQueryKey(
      parameters: DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
    ): ServiceOperationQueryKey<
      GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
      GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          TData,
          ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          TData,
          ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
      GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useInfiniteQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
      TQueryFnData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
      TData = OperationInfiniteData<TQueryFnData, GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useInfiniteQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
      TQueryFnData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
      TData = OperationInfiniteData<TQueryFnData, GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetTotal = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetByParametersTotal = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             field_name: fieldName
     *         },
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetResults = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 field_name: fieldName1
     *             },
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 field_name: fieldName2
     *             },
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getDistinctValuesExternalCallsDistinctValuesFieldNameGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetCombinedResults = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 field_name: fieldName1
     *             },
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 field_name: fieldName2
     *             },
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getDistinctValuesExternalCallsDistinctValuesFieldNameGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useSuspenseQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          TData,
          ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useSuspenseInfiniteQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
      TData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          OperationInfiniteData<TData, GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetData = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 field_name: fieldName1
     *             },
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 field_name: fieldName2
     *             },
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getDistinctValuesExternalCallsDistinctValuesFieldNameGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetCombinedData = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 field_name: fieldName1
     *             },
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 field_name: fieldName2
     *             },
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getDistinctValuesExternalCallsDistinctValuesFieldNameGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    fetchInfiniteQuery<TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        DeepReadonly<TPageParam>,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
      >
    >;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    prefetchInfiniteQuery<TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        DeepReadonly<TPageParam>,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    ensureInfiniteQueryData<TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        DeepReadonly<TPageParam>,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
      >
    >;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
    ): GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
    ):
      | OperationInfiniteData<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
        >
      | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
                    GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
            >,
            data: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData | undefined,
          ]
        >;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
    ):
      | QueryState<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
      updater: Updater<
        NoInfer<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData> | undefined,
        NoInfer<DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
                GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
        >
      | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >,
      updater: Updater<
        NoInfer<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData> | undefined,
        NoInfer<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData | undefined>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        TInfinite,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
    ): void;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
    ): number;
    schema: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema;
    types: {
      parameters: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters;
      data: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData;
      error: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError;
    };
  };
  /**
   * @summary Get Recording Media Url
   * @description Fetch the media URL for a single external call recording by its ID.
   */
  getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet: {
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            TMeta,
            TSignal
          >,
      client?: (
        schema: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        options: {
          parameters: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
    ): ServiceOperationQueryKey<
      GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
      GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          TData,
          ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<
      TData,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          TData,
          ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<
      TData,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
      GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
      TQueryFnData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<
      TData,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
      TQueryFnData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetTotal = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetByParametersTotal = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             external_call_id: externalCallId,
     *             external_call_recording_id: externalCallRecordingId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetResults = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1,
     *                 external_call_recording_id: externalCallRecordingId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2,
     *                 external_call_recording_id: externalCallRecordingId2
     *             }
     *         }
     *     ]
     * });
     * getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetCombinedResults = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1,
     *                 external_call_recording_id: externalCallRecordingId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2,
     *                 external_call_recording_id: externalCallRecordingId2
     *             }
     *         }
     *     ]
     * });
     * getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useSuspenseQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<
      TData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
    >(
      parameters:
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          TData,
          ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<
      TData,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useSuspenseInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
      TData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          OperationInfiniteData<
            TData,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
          ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<
        TData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
      >,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1,
     *                 external_call_recording_id: externalCallRecordingId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2,
     *                 external_call_recording_id: externalCallRecordingId2
     *             }
     *         }
     *     ]
     * });
     * getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetCombinedData = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1,
     *                 external_call_recording_id: externalCallRecordingId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2,
     *                 external_call_recording_id: externalCallRecordingId2
     *             }
     *         }
     *     ]
     * });
     * getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    fetchInfiniteQuery<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
    >(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        DeepReadonly<TPageParam>,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
      >
    >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    prefetchInfiniteQuery<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
    >(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        DeepReadonly<TPageParam>,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    ensureInfiniteQueryData<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
    >(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        DeepReadonly<TPageParam>,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
      >
    >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
    ): GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
    ):
      | OperationInfiniteData<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
        >
      | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
                    GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
            >,
            data:
              | GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData
              | undefined,
          ]
        >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
    ):
      | QueryState<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
      updater: Updater<
        | NoInfer<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>
        | undefined,
        | NoInfer<
            DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
                GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
        >
      | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >,
      updater: Updater<
        | NoInfer<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>
        | undefined,
        | NoInfer<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>
        | undefined
      >,
      options?: SetDataOptions
    ): Array<
      GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData | undefined
    >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        TInfinite,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
    ): void;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
    ): number;
    schema: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema;
    types: {
      parameters: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters;
      data: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData;
      error: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError;
    };
  };
  /**
   * @summary Get Aggregate Metrics
   * @description Return aggregated metrics for calls, grouped by CSR (user_name).
   */
  getAggregateMetricsExternalCallsMetricsAggregateGet: {
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        options: {
          parameters: GetAggregateMetricsExternalCallsMetricsAggregateGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    >;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueryKey(
      parameters: DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
    ): ServiceOperationQueryKey<
      GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
      GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAggregateMetricsExternalCallsMetricsAggregateGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          TData,
          ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAggregateMetricsExternalCallsMetricsAggregateGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          TData,
          ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
      GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useInfiniteQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             group_by: initialGroupBy,
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
      TQueryFnData = GetAggregateMetricsExternalCallsMetricsAggregateGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useInfiniteQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             group_by: initialGroupBy,
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
      TQueryFnData = GetAggregateMetricsExternalCallsMetricsAggregateGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetTotal = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetByParametersTotal = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             group_by: groupBy,
     *             from_date: fromDate,
     *             to_date: toDate
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetResults = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 group_by: groupBy1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 group_by: groupBy2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getAggregateMetricsExternalCallsMetricsAggregateGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetCombinedResults = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 group_by: groupBy1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 group_by: groupBy2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getAggregateMetricsExternalCallsMetricsAggregateGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
          GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useSuspenseQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetAggregateMetricsExternalCallsMetricsAggregateGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          TData,
          ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useSuspenseInfiniteQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             group_by: initialGroupBy,
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
      TData = GetAggregateMetricsExternalCallsMetricsAggregateGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          OperationInfiniteData<TData, GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetData = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 group_by: groupBy1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 group_by: groupBy2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getAggregateMetricsExternalCallsMetricsAggregateGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetCombinedData = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 group_by: groupBy1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 group_by: groupBy2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getAggregateMetricsExternalCallsMetricsAggregateGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
          GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetAggregateMetricsExternalCallsMetricsAggregateGetData,
              GetAggregateMetricsExternalCallsMetricsAggregateGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<GetAggregateMetricsExternalCallsMetricsAggregateGetData>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<GetAggregateMetricsExternalCallsMetricsAggregateGetData>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    fetchInfiniteQuery<TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        DeepReadonly<TPageParam>,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
      >
    >;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    prefetchInfiniteQuery<TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        DeepReadonly<TPageParam>,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    ensureInfiniteQueryData<TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        DeepReadonly<TPageParam>,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
      >
    >;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
    ): GetAggregateMetricsExternalCallsMetricsAggregateGetData | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
    ):
      | OperationInfiniteData<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
        >
      | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
              GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetAggregateMetricsExternalCallsMetricsAggregateGetData,
                    GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
              GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
            >,
            data: GetAggregateMetricsExternalCallsMetricsAggregateGetData | undefined,
          ]
        >;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
    ):
      | QueryState<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
      updater: Updater<
        NoInfer<GetAggregateMetricsExternalCallsMetricsAggregateGetData> | undefined,
        NoInfer<DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAggregateMetricsExternalCallsMetricsAggregateGetData | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetAggregateMetricsExternalCallsMetricsAggregateGetData,
              GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetAggregateMetricsExternalCallsMetricsAggregateGetData,
                GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
        >
      | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >,
      updater: Updater<
        NoInfer<GetAggregateMetricsExternalCallsMetricsAggregateGetData> | undefined,
        NoInfer<GetAggregateMetricsExternalCallsMetricsAggregateGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAggregateMetricsExternalCallsMetricsAggregateGetData | undefined>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        TInfinite,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
    ): void;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
    ): number;
    schema: GetAggregateMetricsExternalCallsMetricsAggregateGetSchema;
    types: {
      parameters: GetAggregateMetricsExternalCallsMetricsAggregateGetParameters;
      data: GetAggregateMetricsExternalCallsMetricsAggregateGetData;
      error: GetAggregateMetricsExternalCallsMetricsAggregateGetError;
    };
  };
  /**
   * @summary Get Call Stats
   * @description Return aggregated metrics for calls for a given team.
   */
  getCallStatsExternalCallsAggregateCallStatsGet: {
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetCallStatsExternalCallsAggregateCallStatsGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        options: {
          parameters: GetCallStatsExternalCallsAggregateCallStatsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    >;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    getQueryKey(
      parameters: DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
    ): ServiceOperationQueryKey<
      GetCallStatsExternalCallsAggregateCallStatsGetSchema,
      GetCallStatsExternalCallsAggregateCallStatsGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCallStatsExternalCallsAggregateCallStatsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCallStatsExternalCallsAggregateCallStatsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetCallStatsExternalCallsAggregateCallStatsGetSchema,
      GetCallStatsExternalCallsAggregateCallStatsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useInfiniteQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters,
      TQueryFnData = GetCallStatsExternalCallsAggregateCallStatsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useInfiniteQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters,
      TQueryFnData = GetCallStatsExternalCallsAggregateCallStatsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetTotal = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetByParametersTotal = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             from_date: fromDate,
     *             to_date: toDate
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetResults = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsExternalCallsAggregateCallStatsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetCombinedResults = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsExternalCallsAggregateCallStatsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetCallStatsExternalCallsAggregateCallStatsGetSchema,
          GetCallStatsExternalCallsAggregateCallStatsGetParameters,
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useSuspenseQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetCallStatsExternalCallsAggregateCallStatsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useSuspenseInfiniteQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters,
      TData = GetCallStatsExternalCallsAggregateCallStatsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          OperationInfiniteData<TData, GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetData = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsExternalCallsAggregateCallStatsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetCombinedData = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsExternalCallsAggregateCallStatsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetCallStatsExternalCallsAggregateCallStatsGetSchema,
          GetCallStatsExternalCallsAggregateCallStatsGetParameters,
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetCallStatsExternalCallsAggregateCallStatsGetData,
              GetCallStatsExternalCallsAggregateCallStatsGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<GetCallStatsExternalCallsAggregateCallStatsGetData>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<GetCallStatsExternalCallsAggregateCallStatsGetData>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    fetchInfiniteQuery<TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        DeepReadonly<TPageParam>,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters
      >
    >;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    prefetchInfiniteQuery<TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        DeepReadonly<TPageParam>,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    ensureInfiniteQueryData<TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        DeepReadonly<TPageParam>,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters
      >
    >;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
    ): GetCallStatsExternalCallsAggregateCallStatsGetData | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
    ):
      | OperationInfiniteData<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetParameters
        >
      | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetCallStatsExternalCallsAggregateCallStatsGetSchema,
              GetCallStatsExternalCallsAggregateCallStatsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetCallStatsExternalCallsAggregateCallStatsGetData,
                    GetCallStatsExternalCallsAggregateCallStatsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetCallStatsExternalCallsAggregateCallStatsGetSchema,
              GetCallStatsExternalCallsAggregateCallStatsGetParameters
            >,
            data: GetCallStatsExternalCallsAggregateCallStatsGetData | undefined,
          ]
        >;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
    ):
      | QueryState<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
      updater: Updater<
        NoInfer<GetCallStatsExternalCallsAggregateCallStatsGetData> | undefined,
        NoInfer<DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetCallStatsExternalCallsAggregateCallStatsGetData | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetCallStatsExternalCallsAggregateCallStatsGetData,
              GetCallStatsExternalCallsAggregateCallStatsGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetCallStatsExternalCallsAggregateCallStatsGetData,
                GetCallStatsExternalCallsAggregateCallStatsGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetParameters
        >
      | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >,
      updater: Updater<
        NoInfer<GetCallStatsExternalCallsAggregateCallStatsGetData> | undefined,
        NoInfer<GetCallStatsExternalCallsAggregateCallStatsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetCallStatsExternalCallsAggregateCallStatsGetData | undefined>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        TInfinite,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
    ): void;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls for a given team.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
    ): number;
    schema: GetCallStatsExternalCallsAggregateCallStatsGetSchema;
    types: {
      parameters: GetCallStatsExternalCallsAggregateCallStatsGetParameters;
      data: GetCallStatsExternalCallsAggregateCallStatsGetData;
      error: GetCallStatsExternalCallsAggregateCallStatsGetError;
    };
  };
  /**
   * @summary Get Call Stats Details
   * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
   * Only includes calls from employees who are members of the specified team.
   */
  getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet: {
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            TMeta,
            TSignal
          >,
      client?: (
        schema: GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
        options: {
          parameters: GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
      >
    >;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    getQueryKey(
      parameters: DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>
    ): ServiceOperationQueryKey<
      GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
      GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useQuery({
     *     query: {
     *         team_id: teamId,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useQuery({
     *     query: {
     *         team_id: teamId,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError>>;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
      GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useInfiniteQuery({
     *     query: {
     *         team_id: teamId,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             team_id: initialTeamId,
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
      TQueryFnData = GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useInfiniteQuery({
     *     query: {
     *         team_id: teamId,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             team_id: initialTeamId,
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
      TQueryFnData = GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetTotal = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetByParametersTotal = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             team_id: teamId,
     *             from_date: fromDate,
     *             to_date: toDate
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetResults = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 team_id: teamId1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 team_id: teamId2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetCombinedResults = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 team_id: teamId1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 team_id: teamId2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useSuspenseQuery({
     *     query: {
     *         team_id: teamId,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useSuspenseInfiniteQuery({
     *     query: {
     *         team_id: teamId,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             team_id: initialTeamId,
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
      TData = GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError,
          OperationInfiniteData<TData, GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>,
      OperationError<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 team_id: teamId1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 team_id: teamId2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetCombinedData = qraft.externalCallsService.getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 team_id: teamId1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 team_id: teamId2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
              GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
      >
    ): Promise<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData>;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
      >
    ): Promise<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData>;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    fetchInfiniteQuery<TPageParam extends GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
        DeepReadonly<TPageParam>,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
      >
    >;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    prefetchInfiniteQuery<TPageParam extends GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
        DeepReadonly<TPageParam>,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    ensureInfiniteQueryData<TPageParam extends GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
        DeepReadonly<TPageParam>,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
      >
    >;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>
    ): GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData | undefined;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>
    ):
      | OperationInfiniteData<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
        >
      | undefined;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
              GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
                    GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
              GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
            >,
            data: GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData | undefined,
          ]
        >;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>
    ):
      | QueryState<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
        >
      | undefined;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
        >
      | undefined;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>
        | ServiceOperationQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >,
      updater: Updater<
        NoInfer<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData> | undefined,
        NoInfer<DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData | undefined;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
              GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
                GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
          GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters
        >
      | undefined;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >,
      updater: Updater<
        NoInfer<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData> | undefined,
        NoInfer<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData | undefined>;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
        TInfinite,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
        GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
    ): void;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats Details
     * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
     * Only includes calls from employees who are members of the specified team.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData,
            TInfinite,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters,
            GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError
          >
    ): number;
    schema: GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema;
    types: {
      parameters: GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters;
      data: GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData;
      error: GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError;
    };
  };
  /**
   * @summary Override Call Metrics
   * @description Override call metrics for a given call.
   */
  overrideCallMetricsExternalCallsExternalCallIdMetricsPatch: {
    /**
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
        options: ServiceOperationMutationFnOptions<
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError
        >
      >
    ): Promise<
      RequestFnResponse<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError
      >
    >;
    /**
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     */
    getMutationKey(
      parameters: DeepReadonly<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters> | void
    ): ServiceOperationMutationKey<
      OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
      OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutation({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody, TContext = unknown>(
      parameters: DeepReadonly<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
        TVariables,
        OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
        TContext
      >
    ): UseMutationResult<
      OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
      OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutation({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
        TVariables,
        OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
        TContext
      >
    ): UseMutationResult<
      OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
      OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const overrideCallMetricsExternalCallsExternalCallIdMetricsPatchTotal = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const overrideCallMetricsExternalCallsExternalCallIdMetricsPatchTotal = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             external_call_id: externalCallId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const overrideCallMetricsExternalCallsExternalCallIdMetricsPatchPendingMutationVariables = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const overrideCallMetricsExternalCallsExternalCallIdMetricsPatchMutationData = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 external_call_id: externalCallId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
        OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
        MutationVariables<
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
          OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
          MutationVariables<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             external_call_id: externalCallId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
              OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
              OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
              TContext
            >
      ):
        | Mutation<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError,
            MutationVariables<
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
              OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
              OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError,
          MutationVariables<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
          >,
          TContext
        >
      >;
    };
    schema: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema;
    types: {
      parameters: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters;
      data: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData;
      error: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError;
      body: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody;
    };
  };
  /**
   * @summary Assign Employee
   * @description Reassign a call to an employee.
   *
   * SOL-2636: the previous "propagate to nearby calls" cascade has been
   * removed -- it relied on the same broken `user_name ILIKE`-style
   * filter that caused Recon's 4,727 mis-attributed historic rows. The
   * extension-based pipeline (ingest + cascade endpoint + dashboard
   * backfill) covers what that cascade used to do, without the wild
   * guessing. A MANUAL audit row is written for every non-no-op
   * transition.
   */
  assignEmployeeExternalCallsExternalCallIdEmployeePost: {
    /**
     * @summary Assign Employee
     * @description Reassign a call to an employee.
     *
     * SOL-2636: the previous "propagate to nearby calls" cascade has been
     * removed -- it relied on the same broken `user_name ILIKE`-style
     * filter that caused Recon's 4,727 mis-attributed historic rows. The
     * extension-based pipeline (ingest + cascade endpoint + dashboard
     * backfill) covers what that cascade used to do, without the wild
     * guessing. A MANUAL audit row is written for every non-no-op
     * transition.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
        AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema,
        options: ServiceOperationMutationFnOptions<
          AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
          AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
          AssignEmployeeExternalCallsExternalCallIdEmployeePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
        AssignEmployeeExternalCallsExternalCallIdEmployeePostError
      >
    >;
    /**
     * @summary Assign Employee
     * @description Reassign a call to an employee.
     *
     * SOL-2636: the previous "propagate to nearby calls" cascade has been
     * removed -- it relied on the same broken `user_name ILIKE`-style
     * filter that caused Recon's 4,727 mis-attributed historic rows. The
     * extension-based pipeline (ingest + cascade endpoint + dashboard
     * backfill) covers what that cascade used to do, without the wild
     * guessing. A MANUAL audit row is written for every non-no-op
     * transition.
     */
    getMutationKey(
      parameters: DeepReadonly<AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters> | void
    ): ServiceOperationMutationKey<
      AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema,
      AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Assign Employee
     * @description Reassign a call to an employee.
     *
     * SOL-2636: the previous "propagate to nearby calls" cascade has been
     * removed -- it relied on the same broken `user_name ILIKE`-style
     * filter that caused Recon's 4,727 mis-attributed historic rows. The
     * extension-based pipeline (ingest + cascade endpoint + dashboard
     * backfill) covers what that cascade used to do, without the wild
     * guessing. A MANUAL audit row is written for every non-no-op
     * transition.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.assignEmployeeExternalCallsExternalCallIdEmployeePost.useMutation({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.assignEmployeeExternalCallsExternalCallIdEmployeePost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends AssignEmployeeExternalCallsExternalCallIdEmployeePostBody, TContext = unknown>(
      parameters: DeepReadonly<AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema,
        AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
        AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
        TVariables,
        OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
        TContext
      >
    ): UseMutationResult<
      AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
      OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Assign Employee
     * @description Reassign a call to an employee.
     *
     * SOL-2636: the previous "propagate to nearby calls" cascade has been
     * removed -- it relied on the same broken `user_name ILIKE`-style
     * filter that caused Recon's 4,727 mis-attributed historic rows. The
     * extension-based pipeline (ingest + cascade endpoint + dashboard
     * backfill) covers what that cascade used to do, without the wild
     * guessing. A MANUAL audit row is written for every non-no-op
     * transition.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.assignEmployeeExternalCallsExternalCallIdEmployeePost.useMutation({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.assignEmployeeExternalCallsExternalCallIdEmployeePost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
        AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema,
        AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
        AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
        TVariables,
        OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
        TContext
      >
    ): UseMutationResult<
      AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
      OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Assign Employee
     * @description Reassign a call to an employee.
     *
     * SOL-2636: the previous "propagate to nearby calls" cascade has been
     * removed -- it relied on the same broken `user_name ILIKE`-style
     * filter that caused Recon's 4,727 mis-attributed historic rows. The
     * extension-based pipeline (ingest + cascade endpoint + dashboard
     * backfill) covers what that cascade used to do, without the wild
     * guessing. A MANUAL audit row is written for every non-no-op
     * transition.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const assignEmployeeExternalCallsExternalCallIdEmployeePostTotal = qraft.externalCallsService.assignEmployeeExternalCallsExternalCallIdEmployeePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const assignEmployeeExternalCallsExternalCallIdEmployeePostTotal = qraft.externalCallsService.assignEmployeeExternalCallsExternalCallIdEmployeePost.useIsMutating({
     *     parameters: {
     *         path: {
     *             external_call_id: externalCallId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
            OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
            OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Assign Employee
     * @description Reassign a call to an employee.
     *
     * SOL-2636: the previous "propagate to nearby calls" cascade has been
     * removed -- it relied on the same broken `user_name ILIKE`-style
     * filter that caused Recon's 4,727 mis-attributed historic rows. The
     * extension-based pipeline (ingest + cascade endpoint + dashboard
     * backfill) covers what that cascade used to do, without the wild
     * guessing. A MANUAL audit row is written for every non-no-op
     * transition.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const assignEmployeeExternalCallsExternalCallIdEmployeePostPendingMutationVariables = qraft.externalCallsService.assignEmployeeExternalCallsExternalCallIdEmployeePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const assignEmployeeExternalCallsExternalCallIdEmployeePostMutationData = qraft.externalCallsService.assignEmployeeExternalCallsExternalCallIdEmployeePost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 external_call_id: externalCallId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
        OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
        MutationVariables<
          AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
          AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
            OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
            OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
          OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
          MutationVariables<
            AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Assign Employee
     * @description Reassign a call to an employee.
     *
     * SOL-2636: the previous "propagate to nearby calls" cascade has been
     * removed -- it relied on the same broken `user_name ILIKE`-style
     * filter that caused Recon's 4,727 mis-attributed historic rows. The
     * extension-based pipeline (ingest + cascade endpoint + dashboard
     * backfill) covers what that cascade used to do, without the wild
     * guessing. A MANUAL audit row is written for every non-no-op
     * transition.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
            OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
            OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Assign Employee
     * @description Reassign a call to an employee.
     *
     * SOL-2636: the previous "propagate to nearby calls" cascade has been
     * removed -- it relied on the same broken `user_name ILIKE`-style
     * filter that caused Recon's 4,727 mis-attributed historic rows. The
     * extension-based pipeline (ingest + cascade endpoint + dashboard
     * backfill) covers what that cascade used to do, without the wild
     * guessing. A MANUAL audit row is written for every non-no-op
     * transition.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.externalCallsService.assignEmployeeExternalCallsExternalCallIdEmployeePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             external_call_id: externalCallId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.externalCallsService.assignEmployeeExternalCallsExternalCallIdEmployeePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
              AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
              AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
              OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema,
              AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
              AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
              AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
              OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
              TContext
            >
      ):
        | Mutation<
            AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostError,
            MutationVariables<
              AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
              AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
              AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
              AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
              OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema,
              AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
              AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
              AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters,
              OperationError<AssignEmployeeExternalCallsExternalCallIdEmployeePostError>,
              TContext
            >
      ): Array<
        Mutation<
          AssignEmployeeExternalCallsExternalCallIdEmployeePostData,
          AssignEmployeeExternalCallsExternalCallIdEmployeePostError,
          MutationVariables<
            AssignEmployeeExternalCallsExternalCallIdEmployeePostBody,
            AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters
          >,
          TContext
        >
      >;
    };
    schema: AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema;
    types: {
      parameters: AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters;
      data: AssignEmployeeExternalCallsExternalCallIdEmployeePostData;
      error: AssignEmployeeExternalCallsExternalCallIdEmployeePostError;
      body: AssignEmployeeExternalCallsExternalCallIdEmployeePostBody;
    };
  };
}
/** @summary Search */
export const searchExternalCallsGet = {
  schema: {
    method: 'get',
    url: '/external_calls',
    security: ['HTTPBearer'],
  },
} as {
  schema: SearchExternalCallsGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['searchExternalCallsGet'];
};
/** @summary Metrics Registry */
export const metricsRegistryExternalCallsMetricsRegistryGet = {
  schema: {
    method: 'get',
    url: '/external_calls/metrics_registry',
    security: ['HTTPBearer'],
  },
} as {
  schema: MetricsRegistryExternalCallsMetricsRegistryGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['metricsRegistryExternalCallsMetricsRegistryGet'];
};
/**
 * @summary Unmapped Extensions
 * @description SOL-2636 Point 4. Recent inbound extensions with no employee
 * mapping -- drives the dashboard banner.
 */
export const unmappedExtensions = {
  schema: {
    method: 'get',
    url: '/external_calls/unmapped_extensions',
    security: ['HTTPBearer'],
  },
} as {
  schema: UnmappedExtensionsSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['unmappedExtensions'];
};
/**
 * @summary Backfill Attribution Preview
 * @description SOL-2636 Point 7. Preview the row count the backfill button
 * would re-attribute under the current dashboard filters.
 */
export const backfillAttributionPreview = {
  schema: {
    method: 'get',
    url: '/external_calls/backfill_attribution/preview',
    security: ['HTTPBearer'],
  },
} as {
  schema: BackfillAttributionPreviewSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['backfillAttributionPreview'];
};
/**
 * @summary Backfill Attribution
 * @description SOL-2636 Point 7. Execute the historic re-attribution under the
 * current dashboard filters. Server-side hard limit 10,000 rows --
 * larger backfills go through scripts/backfill_recon_attribution.py
 * (chunked + retry semantics).
 */
export const backfillAttribution = {
  schema: {
    method: 'post',
    url: '/external_calls/backfill_attribution',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: BackfillAttributionSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['backfillAttribution'];
};
/**
 * @summary Re Eval Preview
 * @description Counts for the Re-eval LLM dialog under the current dashboard
 * filters: the eligible total and the no-analysis subset, both already
 * restricted to the calls the evaluator would actually score.
 */
export const reEvalPreview = {
  schema: {
    method: 'get',
    url: '/external_calls/re_eval/preview',
    security: ['HTTPBearer'],
  },
} as {
  schema: ReEvalPreviewSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['reEvalPreview'];
};
/**
 * @summary Re Eval
 * @description Submit eval jobs for the eligible calls under the current filters.
 * `include_already_evaluated=false` re-evaluates calls with no analysis yet
 * plus calls pinned to a retired metric version (ADR-023); `true` also
 * re-scores calls that already have a current one.
 * Hard limit 10,000 -> 409 too_large.
 */
export const reEval = {
  schema: {
    method: 'post',
    url: '/external_calls/re_eval',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: ReEvalSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['reEval'];
};
/**
 * @summary Recompute Scores Preview
 * @description SOL-2636 Issue 2. Preview the on-demand recompute under the current dashboard
 * filters: how many scored calls are in scope, whether the office has recompute history,
 * and which metrics would change (rules differ vs the version they were scored under).
 */
export const recomputeScoresPreview = {
  schema: {
    method: 'get',
    url: '/external_calls/recompute_scores/preview',
    security: ['HTTPBearer'],
  },
} as {
  schema: RecomputeScoresPreviewSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['recomputeScoresPreview'];
};
/**
 * @summary Recompute Scores
 * @description SOL-2636 Issue 2. Re-aggregate call_avg_score for the scoped calls under
 * latest-active rules. Writes only call_avg_score; never re-runs the LLM. Hard limit
 * 10,000 (larger runs go through the CLI dispatcher).
 */
export const recomputeScores = {
  schema: {
    method: 'post',
    url: '/external_calls/recompute_scores',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: RecomputeScoresSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['recomputeScores'];
};
/**
 * @summary Metrics Version Spread
 * @description SOL-2636 Issue 2 (Q2). Per metric, how many definition versions the in-scope calls
 * span and what the current version is — drives the "Edited this period" chip. Read-only.
 *
 * Deliberately NOT admin-gated (unlike the recompute write/preview endpoints): this is an
 * informational read that feeds the same dashboard view as the (non-admin) call-stats
 * aggregate endpoint, so non-admin office managers viewing the dashboard must see it too.
 * Office-scoped via the pin check below.
 */
export const metricsVersionSpread = {
  schema: {
    method: 'get',
    url: '/external_calls/metrics/version_spread',
    security: ['HTTPBearer'],
  },
} as {
  schema: MetricsVersionSpreadSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['metricsVersionSpread'];
};
/**
 * @summary Get By Id
 * @description Fetch a single external call by its ID.
 */
export const getByIdExternalCallsExternalCallIdGet = {
  schema: {
    method: 'get',
    url: '/external_calls/{external_call_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetByIdExternalCallsExternalCallIdGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['getByIdExternalCallsExternalCallIdGet'];
};
/**
 * @summary Get Distinct Values
 * @description Return distinct values for a given ExternalCall field for the provided office.
 */
export const getDistinctValuesExternalCallsDistinctValuesFieldNameGet = {
  schema: {
    method: 'get',
    url: '/external_calls/distinct_values/{field_name}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['getDistinctValuesExternalCallsDistinctValuesFieldNameGet'];
};
/**
 * @summary Get Recording Media Url
 * @description Fetch the media URL for a single external call recording by its ID.
 */
export const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet = {
  schema: {
    method: 'get',
    url: '/external_calls/{external_call_id}/recording/{external_call_recording_id}/media_url',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet'];
};
/**
 * @summary Get Aggregate Metrics
 * @description Return aggregated metrics for calls, grouped by CSR (user_name).
 */
export const getAggregateMetricsExternalCallsMetricsAggregateGet = {
  schema: {
    method: 'get',
    url: '/external_calls/metrics/aggregate',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAggregateMetricsExternalCallsMetricsAggregateGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['getAggregateMetricsExternalCallsMetricsAggregateGet'];
};
/**
 * @summary Get Call Stats
 * @description Return aggregated metrics for calls for a given team.
 */
export const getCallStatsExternalCallsAggregateCallStatsGet = {
  schema: {
    method: 'get',
    url: '/external_calls/aggregate/call_stats',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetCallStatsExternalCallsAggregateCallStatsGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['getCallStatsExternalCallsAggregateCallStatsGet'];
};
/**
 * @summary Get Call Stats Details
 * @description Return aggregated metrics for calls for a given team with detailed metrics breakdown.
 * Only includes calls from employees who are members of the specified team.
 */
export const getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet = {
  schema: {
    method: 'get',
    url: '/external_calls/aggregate/call_stats_details',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet'];
};
/**
 * @summary Override Call Metrics
 * @description Override call metrics for a given call.
 */
export const overrideCallMetricsExternalCallsExternalCallIdMetricsPatch = {
  schema: {
    method: 'patch',
    url: '/external_calls/{external_call_id}/metrics',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['overrideCallMetricsExternalCallsExternalCallIdMetricsPatch'];
};
/**
 * @summary Assign Employee
 * @description Reassign a call to an employee.
 *
 * SOL-2636: the previous "propagate to nearby calls" cascade has been
 * removed -- it relied on the same broken `user_name ILIKE`-style
 * filter that caused Recon's 4,727 mis-attributed historic rows. The
 * extension-based pipeline (ingest + cascade endpoint + dashboard
 * backfill) covers what that cascade used to do, without the wild
 * guessing. A MANUAL audit row is written for every non-no-op
 * transition.
 */
export const assignEmployeeExternalCallsExternalCallIdEmployeePost = {
  schema: {
    method: 'post',
    url: '/external_calls/{external_call_id}/employee',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['assignEmployeeExternalCallsExternalCallIdEmployeePost'];
};
export const externalCallsService = {
  searchExternalCallsGet,
  metricsRegistryExternalCallsMetricsRegistryGet,
  unmappedExtensions,
  backfillAttributionPreview,
  backfillAttribution,
  reEvalPreview,
  reEval,
  recomputeScoresPreview,
  recomputeScores,
  metricsVersionSpread,
  getByIdExternalCallsExternalCallIdGet,
  getDistinctValuesExternalCallsDistinctValuesFieldNameGet,
  getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet,
  getAggregateMetricsExternalCallsMetricsAggregateGet,
  getCallStatsExternalCallsAggregateCallStatsGet,
  getCallStatsDetailsExternalCallsAggregateCallStatsDetailsGet,
  overrideCallMetricsExternalCallsExternalCallIdMetricsPatch,
  assignEmployeeExternalCallsExternalCallIdEmployeePost,
} as const;
type SearchExternalCallsGetSchema = {
  method: 'get';
  url: '/external_calls';
  security: ['HTTPBearer'];
};
type SearchExternalCallsGetParameters = paths['/external_calls']['get']['parameters'];
type SearchExternalCallsGetData = paths['/external_calls']['get']['responses']['200']['content']['application/json'];
type SearchExternalCallsGetError = paths['/external_calls']['get']['responses']['422']['content']['application/json'];
type MetricsRegistryExternalCallsMetricsRegistryGetSchema = {
  method: 'get';
  url: '/external_calls/metrics_registry';
  security: ['HTTPBearer'];
};
type MetricsRegistryExternalCallsMetricsRegistryGetParameters = undefined;
type MetricsRegistryExternalCallsMetricsRegistryGetData =
  paths['/external_calls/metrics_registry']['get']['responses']['200']['content']['application/json'];
type MetricsRegistryExternalCallsMetricsRegistryGetError = unknown;
type UnmappedExtensionsSchema = {
  method: 'get';
  url: '/external_calls/unmapped_extensions';
  security: ['HTTPBearer'];
};
type UnmappedExtensionsParameters = paths['/external_calls/unmapped_extensions']['get']['parameters'];
type UnmappedExtensionsData =
  paths['/external_calls/unmapped_extensions']['get']['responses']['200']['content']['application/json'];
type UnmappedExtensionsError =
  paths['/external_calls/unmapped_extensions']['get']['responses']['422']['content']['application/json'];
type BackfillAttributionPreviewSchema = {
  method: 'get';
  url: '/external_calls/backfill_attribution/preview';
  security: ['HTTPBearer'];
};
type BackfillAttributionPreviewParameters = paths['/external_calls/backfill_attribution/preview']['get']['parameters'];
type BackfillAttributionPreviewData =
  paths['/external_calls/backfill_attribution/preview']['get']['responses']['200']['content']['application/json'];
type BackfillAttributionPreviewError =
  paths['/external_calls/backfill_attribution/preview']['get']['responses']['422']['content']['application/json'];
type BackfillAttributionSchema = {
  method: 'post';
  url: '/external_calls/backfill_attribution';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type BackfillAttributionParameters = paths['/external_calls/backfill_attribution']['post']['parameters'];
type BackfillAttributionData =
  paths['/external_calls/backfill_attribution']['post']['responses']['200']['content']['application/json'];
type BackfillAttributionError =
  paths['/external_calls/backfill_attribution']['post']['responses']['422']['content']['application/json'];
type BackfillAttributionBody =
  paths['/external_calls/backfill_attribution']['post']['requestBody']['content']['application/json'];
type ReEvalPreviewSchema = {
  method: 'get';
  url: '/external_calls/re_eval/preview';
  security: ['HTTPBearer'];
};
type ReEvalPreviewParameters = paths['/external_calls/re_eval/preview']['get']['parameters'];
type ReEvalPreviewData =
  paths['/external_calls/re_eval/preview']['get']['responses']['200']['content']['application/json'];
type ReEvalPreviewError =
  paths['/external_calls/re_eval/preview']['get']['responses']['422']['content']['application/json'];
type ReEvalSchema = {
  method: 'post';
  url: '/external_calls/re_eval';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type ReEvalParameters = paths['/external_calls/re_eval']['post']['parameters'];
type ReEvalData = paths['/external_calls/re_eval']['post']['responses']['200']['content']['application/json'];
type ReEvalError = paths['/external_calls/re_eval']['post']['responses']['422']['content']['application/json'];
type ReEvalBody = paths['/external_calls/re_eval']['post']['requestBody']['content']['application/json'];
type RecomputeScoresPreviewSchema = {
  method: 'get';
  url: '/external_calls/recompute_scores/preview';
  security: ['HTTPBearer'];
};
type RecomputeScoresPreviewParameters = paths['/external_calls/recompute_scores/preview']['get']['parameters'];
type RecomputeScoresPreviewData =
  paths['/external_calls/recompute_scores/preview']['get']['responses']['200']['content']['application/json'];
type RecomputeScoresPreviewError =
  paths['/external_calls/recompute_scores/preview']['get']['responses']['422']['content']['application/json'];
type RecomputeScoresSchema = {
  method: 'post';
  url: '/external_calls/recompute_scores';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type RecomputeScoresParameters = paths['/external_calls/recompute_scores']['post']['parameters'];
type RecomputeScoresData =
  paths['/external_calls/recompute_scores']['post']['responses']['200']['content']['application/json'];
type RecomputeScoresError =
  paths['/external_calls/recompute_scores']['post']['responses']['422']['content']['application/json'];
type RecomputeScoresBody =
  paths['/external_calls/recompute_scores']['post']['requestBody']['content']['application/json'];
type MetricsVersionSpreadSchema = {
  method: 'get';
  url: '/external_calls/metrics/version_spread';
  security: ['HTTPBearer'];
};
type MetricsVersionSpreadParameters = paths['/external_calls/metrics/version_spread']['get']['parameters'];
type MetricsVersionSpreadData =
  paths['/external_calls/metrics/version_spread']['get']['responses']['200']['content']['application/json'];
type MetricsVersionSpreadError =
  paths['/external_calls/metrics/version_spread']['get']['responses']['422']['content']['application/json'];
type GetByIdExternalCallsExternalCallIdGetSchema = {
  method: 'get';
  url: '/external_calls/{external_call_id}';
  security: ['HTTPBearer'];
};
type GetByIdExternalCallsExternalCallIdGetParameters = paths['/external_calls/{external_call_id}']['get']['parameters'];
type GetByIdExternalCallsExternalCallIdGetData =
  paths['/external_calls/{external_call_id}']['get']['responses']['200']['content']['application/json'];
type GetByIdExternalCallsExternalCallIdGetError =
  paths['/external_calls/{external_call_id}']['get']['responses']['422']['content']['application/json'];
type GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema = {
  method: 'get';
  url: '/external_calls/distinct_values/{field_name}';
  security: ['HTTPBearer'];
};
type GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters =
  paths['/external_calls/distinct_values/{field_name}']['get']['parameters'];
type GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData =
  paths['/external_calls/distinct_values/{field_name}']['get']['responses']['200']['content']['application/json'];
type GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError =
  paths['/external_calls/distinct_values/{field_name}']['get']['responses']['422']['content']['application/json'];
type GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema = {
  method: 'get';
  url: '/external_calls/{external_call_id}/recording/{external_call_recording_id}/media_url';
  security: ['HTTPBearer'];
};
type GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters =
  paths['/external_calls/{external_call_id}/recording/{external_call_recording_id}/media_url']['get']['parameters'];
type GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData =
  paths['/external_calls/{external_call_id}/recording/{external_call_recording_id}/media_url']['get']['responses']['200']['content']['application/json'];
type GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError =
  paths['/external_calls/{external_call_id}/recording/{external_call_recording_id}/media_url']['get']['responses']['422']['content']['application/json'];
type GetAggregateMetricsExternalCallsMetricsAggregateGetSchema = {
  method: 'get';
  url: '/external_calls/metrics/aggregate';
  security: ['HTTPBearer'];
};
type GetAggregateMetricsExternalCallsMetricsAggregateGetParameters =
  paths['/external_calls/metrics/aggregate']['get']['parameters'];
type GetAggregateMetricsExternalCallsMetricsAggregateGetData =
  paths['/external_calls/metrics/aggregate']['get']['responses']['200']['content']['application/json'];
type GetAggregateMetricsExternalCallsMetricsAggregateGetError =
  paths['/external_calls/metrics/aggregate']['get']['responses']['422']['content']['application/json'];
type GetCallStatsExternalCallsAggregateCallStatsGetSchema = {
  method: 'get';
  url: '/external_calls/aggregate/call_stats';
  security: ['HTTPBearer'];
};
type GetCallStatsExternalCallsAggregateCallStatsGetParameters =
  paths['/external_calls/aggregate/call_stats']['get']['parameters'];
type GetCallStatsExternalCallsAggregateCallStatsGetData =
  paths['/external_calls/aggregate/call_stats']['get']['responses']['200']['content']['application/json'];
type GetCallStatsExternalCallsAggregateCallStatsGetError =
  paths['/external_calls/aggregate/call_stats']['get']['responses']['422']['content']['application/json'];
type GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetSchema = {
  method: 'get';
  url: '/external_calls/aggregate/call_stats_details';
  security: ['HTTPBearer'];
};
type GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetParameters =
  paths['/external_calls/aggregate/call_stats_details']['get']['parameters'];
type GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetData =
  paths['/external_calls/aggregate/call_stats_details']['get']['responses']['200']['content']['application/json'];
type GetCallStatsDetailsExternalCallsAggregateCallStatsDetailsGetError =
  paths['/external_calls/aggregate/call_stats_details']['get']['responses']['422']['content']['application/json'];
type OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema = {
  method: 'patch';
  url: '/external_calls/{external_call_id}/metrics';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters =
  paths['/external_calls/{external_call_id}/metrics']['patch']['parameters'];
type OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData = null;
type OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError =
  paths['/external_calls/{external_call_id}/metrics']['patch']['responses']['422']['content']['application/json'];
type OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody =
  paths['/external_calls/{external_call_id}/metrics']['patch']['requestBody']['content']['application/json'];
type AssignEmployeeExternalCallsExternalCallIdEmployeePostSchema = {
  method: 'post';
  url: '/external_calls/{external_call_id}/employee';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type AssignEmployeeExternalCallsExternalCallIdEmployeePostParameters =
  paths['/external_calls/{external_call_id}/employee']['post']['parameters'];
type AssignEmployeeExternalCallsExternalCallIdEmployeePostData =
  paths['/external_calls/{external_call_id}/employee']['post']['responses']['200']['content']['application/json'];
type AssignEmployeeExternalCallsExternalCallIdEmployeePostError =
  paths['/external_calls/{external_call_id}/employee']['post']['responses']['422']['content']['application/json'];
type AssignEmployeeExternalCallsExternalCallIdEmployeePostBody =
  paths['/external_calls/{external_call_id}/employee']['post']['requestBody']['content']['application/json'];
